(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.AudioPlayer = factory());
})(this, function () {
  'use strict';
  /*! *****************************************************************************
  Copyright (c) Microsoft Corporation. All rights reserved.
  Licensed under the Apache License, Version 2.0 (the "License"); you may not use
  this file except in compliance with the License. You may obtain a copy of the
  License at http://www.apache.org/licenses/LICENSE-2.0
    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
  KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
  WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
  MERCHANTABLITY OR NON-INFRINGEMENT.
    See the Apache Version 2.0 License for specific language governing permissions
  and limitations under the License.
  ***************************************************************************** */

  var _assign = function __assign() {
    _assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
      }

      return t;
    };

    return _assign.apply(this, arguments);
  };

  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  function createCommonjsModule(fn) {
    var module = {
      exports: {}
    };
    return fn(module, module.exports), module.exports;
  }

  var main_min$1 = createCommonjsModule(function (module, exports) {
    !function (e, t) {
      module.exports = t();
    }(commonjsGlobal, function () {
      function l(e) {
        return (l = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }

      function t(t, e) {
        var n = Object.keys(t);

        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }

        return n;
      }

      function m(o) {
        for (var e = 1; e < arguments.length; e++) {
          var i = null != arguments[e] ? arguments[e] : {};
          e % 2 ? t(i, !0).forEach(function (e) {
            var t, n, r;
            t = o, r = i[n = e], n in t ? Object.defineProperty(t, n, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : t[n] = r;
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(i)) : t(i).forEach(function (e) {
            Object.defineProperty(o, e, Object.getOwnPropertyDescriptor(i, e));
          });
        }

        return o;
      }

      function i(e, t) {
        if (null != e) if ("object" !== l(e) && (e = [e]), a(e)) for (var n = 0, r = e.length; n < r; n++) {
          t.call(null, e[n], n, e);
        } else for (var o in e) {
          Object.prototype.hasOwnProperty.call(e, o) && t.call(null, e[o], o, e);
        }
      }

      function a(e) {
        return "[object Array]" === Object.prototype.toString.call(e);
      }

      function n(e) {
        return null == e || "" === e;
      }

      var c = {
        forEach: i,
        isArray: a,
        trim: function trim(e) {
          return n(e) ? "" : e.replace(/^\s*/, "").replace(/\s*$/, "");
        },
        isEmpty: n,
        deepMerge: function n() {
          var r = {};

          function e(e, t) {
            "object" === l(r[t]) && "object" === l(e) && !e instanceof Array ? r[t] = n(r[t], e) : "object" === l(e) && !e instanceof Array ? r[t] = n({}, e) : r[t] = e;
          }

          for (var t = 0, o = arguments.length; t < o; t++) {
            i(arguments[t], e);
          }

          return r;
        },
        extend: function extend(n, e, r) {
          return i(e, function (e, t) {
            n[t] = r && "function" == typeof e ? e.bind(r) : e;
          }), n;
        },
        objToParamStr: function objToParamStr(t) {
          var n = "";
          return Object.keys(t).forEach(function (e) {
            n += "" == n ? e + "=" + t[e] : "&" + e + "=" + t[e];
          }), n;
        },
        toast: function toast(e) {
          var t = document.createElement("div"),
              n = document.createElement("div");
          e.duration = e.duration ? e.duration : 3e3, t.style.cssText = "position: fixed; top: 0; left: 0; width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; z-index:100000; text-align:center;", t.id = "toastCover", n.style.cssText = "background:rgba(0, 0, 0, .6); border-radius: 0.10rem; color: #fff; min-width: 40%; max-width: 80%; padding: 0.20rem; font-size: 0.28rem;", n.id = "toastText", n.innerText = e.message, t.appendChild(n), document.body.appendChild(t), setTimeout(function () {
            document.querySelector("#toastCover") && t.parentNode.removeChild(t);
          }, e.duration);
        }
      };

      function r() {
        this.toDoFunctionChain = [];
      }

      function u(e, t, n, r, o) {
        e = e || "";
        var i = new Error(e);
        return i.config = t, i.request = r, i.response = o, c.isEmpty(n) || (i.code = n), i;
      }

      function o(a) {
        return new Promise(function (n, e) {
          var t = a.params,
              r = a.data,
              o = new XMLHttpRequest();
          o = window.XMLHttpRequest ? new XMLHttpRequest() : new window.ActiveXObject();
          var i = a.baseURL + a.url;
          c.isEmpty(a.params) || (i = i + "?" + c.objToParamStr(t)), o.open(a.method, i, a.async), c.isEmpty(a.headers) || c.forEach(a.headers, function (e) {
            o.setRequestHeader(Object.keys(e)[0], e[Object.keys(e)[0]]);
          }), o.timeout = a.timeout, c.isEmpty(a.withCredentials) || (o.withCredentials = a.withCredentials), o.onreadystatechange = function () {
            if (o && 4 === o.readyState && (0 !== o.status || o.responseURL && 0 === o.responseURL.indexOf("file:"))) {
              var e = "getAllResponseHeaders" in o ? function (e) {
                var t = "";
                t = c.isArray(e) ? e : e.split(/\r\n/);

                for (var n = {}, r = 0; r < t.length; r++) {
                  var o = t[r].indexOf(":"),
                      i = c.trim(t[r].substr(0, o)).toLowerCase(),
                      a = c.trim(t[r].substr(o + 1));
                  i && (n[i] = "set-cookie" === i ? (n[i] ? n[i] : []).concat([a]) : n[i] ? n[i] + ", " + a : a);
                }

                return n;
              }(o.getAllResponseHeaders()) : null,
                  t = {
                data: a.responseType && "text" !== a.responseType ? o.response : o.responseText,
                headers: e,
                config: a,
                status: o.status,
                request: o
              };
              n(t);
            }
          }, o.onabort = function () {
            o && (e(u("Request aborted", a, "ECONNABORTED", o)), o = null);
          }, o.onerror = function () {
            e(u("Network Error", a, "ECONNERROR", o)), o = null;
          }, o.ontimeout = function () {
            e(u("request timeout", a, "ECONNTIMEOUT", o)), o = null;
          }, c.isEmpty(r) ? o.send() : "string" == typeof r ? o.send(r) : o.send(JSON.stringify(r));
        });
      }

      r.prototype.on = function (e, t) {
        return this.toDoFunctionChain.push({
          fulfilled: e,
          rejected: t
        }), this.toDoFunctionChain.length - 1;
      }, r.prototype.off = function (e) {
        this.toDoFunctionChain[e] && (this.toDoFunctionChain[e] = null);
      }, r.prototype.forEach = function (t) {
        c.forEach(this.toDoFunctionChain, function (e) {
          null !== e && t(e);
        });
      };
      var b = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof commonjsGlobal ? commonjsGlobal : "undefined" != typeof self ? self : {};

      function e(e, t) {
        return e(t = {
          exports: {}
        }, t.exports), t.exports;
      }

      var g = e(function (e, t) {
        function n(t, e) {
          var n,
              r = Object.keys(t);
          return Object.getOwnPropertySymbols && (n = Object.getOwnPropertySymbols(t), e && (n = n.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), r.push.apply(r, n)), r;
        }

        function i(r) {
          for (var e = 1; e < arguments.length; e++) {
            var o = null != arguments[e] ? arguments[e] : {};
            e % 2 ? n(Object(o), !0).forEach(function (e) {
              var t, n;
              t = r, e = o[n = e], n in t ? Object.defineProperty(t, n, {
                value: e,
                enumerable: !0,
                configurable: !0,
                writable: !0
              }) : t[n] = e;
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(o)) : n(Object(o)).forEach(function (e) {
              Object.defineProperty(r, e, Object.getOwnPropertyDescriptor(o, e));
            });
          }

          return r;
        }

        var l, r;
        e.exports = (l = {
          str2Json: function str2Json(e) {
            var t = {};
            if ("[object String]" === Object.prototype.toString.call(e)) try {
              t = JSON.parse(e);
            } catch (e) {
              t = {};
            }
            return t;
          },
          json2Str: function json2Str(e) {
            var t = e;
            if ("string" != typeof e) try {
              t = JSON.stringify(e);
            } catch (e) {
              t = "";
            }
            return t;
          },
          cbNum: 0,
          isIOS: !!navigator.userAgent.match(/KGBrowser/gi),
          isKugouAndroid: !!navigator.userAgent.match(/kugouandroid/gi),
          isAndroid: "undefined" != typeof external && void 0 !== external.superCall,
          isFXAPP: !!navigator.userAgent.match(/Fanxing/gi),
          isFXQianBanAPP: !!navigator.userAgent.match(/QianBan/gi),
          isIframePage: window.parent && window.parent != window,
          loadUrl: function loadUrl(e) {
            var t = document.createElement("iframe");
            t.setAttribute("src", e), t.setAttribute("style", "display:none;"), t.setAttribute("height", "0px"), t.setAttribute("width", "0px"), t.setAttribute("frameborder", "0"), document.body.appendChild(t), t.parentNode.removeChild(t), t = null;
          },
          mobileCallInIframe: function mobileCallInIframe(e, t, n) {
            e = {
              type: "KgMobileCall",
              cmd: e
            }, t && (e.dataJson = t), n && (e.cbName = n), e.source = "personal", window.parent.postMessage(e, "*");
          },
          receiveMessage: function receiveMessage(e) {
            var t = e.data;
            "KgMobileCall" == t.type && window[t.cbName] && (t.dataJson ? window[t.cbName](t.dataJson) : window[t.cbName](), window[t.cbName] = null), "KgWebMobileCall" == t.type && (e = t.funcName.split("."), KgWebMobileCall[e[1]] && (t.dataJson ? KgWebMobileCall[e[1]](t.dataJson) : KgWebMobileCall[e[1]]()));
          },
          callCmd: function callCmd(n) {
            var e,
                t,
                r = l;

            if (r.isKugouAndroid) {
              var o = {},
                  i = "";
              n.cmd && (o.cmd = n.cmd), n.jsonStr && (o.jsonStr = n.jsonStr), n.callback && (r.cbNum++, i = "kgandroidmobilecall_" + (n.cmd || 0) + "_" + r.cbNum + Math.random().toString().substr(2, 9), o.callback = i, window[i] = function (e, t) {
                if (void 0 !== e) if ("[object String]" === Object.prototype.toString.call(e)) {
                  try {
                    e = "#" === t ? decodeURIComponent(e) : decodeURIComponent(decodeURIComponent(e));
                  } catch (e) {
                    console.error("decodeURIComponent", e);
                  }

                  n.callback(r.str2Json(e));
                } else n.callback(e);
              }), n.AndroidCallback && ((a = r.str2Json(n.jsonStr)).AndroidCallback = i, n.jsonStr = r.json2Str(a), n.jsonStr && (o.jsonStr = n.jsonStr));
              var a = encodeURIComponent(JSON.stringify(o));
              a = "kugoujsbridge://start.kugou_jsbridge/?".concat(a);
              r.isIframePage ? r.mobileCallInIframe(o.cmd, o.jsonStr, i) : r.loadUrl(a);
            } else if (r.isAndroid) {
              var s = "";
              i = "";
              if (n.jsonStr) {
                if (n.callback && "" !== n.callback && !0 === n.AndroidCallback && (r.cbNum++, i = "kgmobilecall_" + (n.cmd || 0) + "_" + r.cbNum + Math.random().toString().substr(2, 9), window[i] = function (e, t) {
                  if (void 0 !== e) if ("[object String]" === Object.prototype.toString.call(e)) {
                    try {
                      e = "#" === t ? decodeURIComponent(e) : decodeURIComponent(decodeURIComponent(e));
                    } catch (e) {
                      console.error("decodeURIComponent", decodeURIComponent);
                    }

                    n.callback(r.str2Json(e));
                  } else n.callback(e);
                }, (a = r.str2Json(n.jsonStr)).AndroidCallback = i, n.jsonStr = r.json2Str(a)), r.isIframePage && n.AndroidCallback) r.mobileCallInIframe(n.cmd, n.jsonStr, i);else try {
                  s = external.superCall(n.cmd, n.jsonStr);
                } catch (e) {}
              } else try {
                s = external.superCall(n.cmd);
              } catch (e) {}
              n.AndroidCallback || n.callback && "" !== n.callback && "AndroidCallback" != s && (s = r.str2Json(s), n.callback(s));
            } else r.isFXAPP || r.isFXQianBanAPP ? (s = t = "", t = n.callback ? (r.cbNum++, s = "kgmobilecall_" + (n.cmd || 0) + "_" + r.cbNum + Math.random().toString().substr(2, 9), window[s] = function (e) {
              void 0 !== e && n.callback && ("[object String]" === Object.prototype.toString.call(e) ? n.callback(r.str2Json(e)) : n.callback(e));
            }, n.jsonStr ? 'fanxing2://send.message/?{"cmd":' + n.cmd + ', "jsonStr":' + n.jsonStr + ', "callback":"' + s + '"}' : 'fanxing2://send.message/?{"cmd":' + n.cmd + ', "callback":"' + s + '"}') : n.jsonStr ? 'fanxing2://send.message/?{"cmd":' + n.cmd + ', "jsonStr":' + n.jsonStr + "}" : 'fanxing2://send.message/?{"cmd":' + n.cmd + "}", r.isIframePage ? r.mobileCallInIframe(n.cmd, n.jsonStr, s) : navigator.userAgent.match(/(Android);?[\s\/]+([\d.]+)?/) ? external && external.callFanxing ? (e = {
              cmd: n.cmd,
              jsonStr: n.jsonStr || "",
              callback: s
            }, external.callFanxing(JSON.stringify(e))) : window.prompt(t) : r.loadUrl(t)) : (t = e = "", n.callback && (r.cbNum++, t = "kgmobilecall_" + (n.cmd || 0) + "_" + r.cbNum + Math.random().toString().substr(2, 9), window[t] = function (e) {
              void 0 !== e && n.callback && ("[object String]" === Object.prototype.toString.call(e) ? n.callback(r.str2Json(e)) : n.callback(e));
            }), t && "" != t && n.jsonStr && (e = 'kugouurl://start.music/?{"cmd":' + n.cmd + ', "jsonStr":' + n.jsonStr + ', "callback":"' + t + '"}'), t && "" != t && !n.jsonStr && (e = 'kugouurl://start.music/?{"cmd":' + n.cmd + ', "callback":"' + t + '"}'), "" == t && n.jsonStr && (e = 'kugouurl://start.music/?{"cmd":' + n.cmd + ', "jsonStr":' + n.jsonStr + "}"), "" != t || n.jsonStr || (e = 'kugouurl://start.music/?{"cmd":' + n.cmd + "}"), r.isIframePage ? r.mobileCallInIframe(n.cmd, n.jsonStr, t) : r.loadUrl(e));
          }
        }, r = {
          isIOS: l.isIOS,
          isKugouAndroid: l.isKugouAndroid,
          isAndroid: l.isAndroid,
          isFXAPP: l.isFXAPP,
          isFXQianBanAPP: l.isFXQianBanAPP,
          isInClient: function isInClient() {
            return !!(l.isAndroid || l.isKugouAndroid || l.isIOS || l.isFXAPP || l.isFXQianBanAPP);
          },
          mobileCall: function mobileCall(e, t, n, r) {
            var o = "";
            if (t && (o = l.json2Str(t)), !e) return console.error("请输入命令号！"), !1;
            t = {}, e && (t.cmd = e), "" != o && (t.jsonStr = o), n && (t.callback = n), t = i(i({}, t), r), !e || 186 != e && 225 != e || n && (t.AndroidCallback = !0), t.AndroidCallback && !t.jsonStr && (t.jsonStr = {}), l.callCmd(t);
          },
          KgWebMobileCall: function KgWebMobileCall(r, o) {
            if (r) try {
              l.isIframePage && window.parent.postMessage({
                type: "KgWebMobileCall",
                funcName: r
              }, "*");
              var i = r.split(".");
              i.reduce(function (e, t) {
                if (e[t]) {
                  if (t !== i[i.length - 1]) return e[t];
                  var n = e[t];
                  return "function" == typeof n ? (e[t] = function () {
                    n && n.apply(void 0, arguments), o && o.apply(void 0, arguments);
                  }, e[t]) : (console.error("请检查，当前环境变量已注册了对象：" + r + "，且该对象不是方法"), null);
                }

                return t === i[i.length - 1] ? e[t] = function () {
                  o && o.apply(void 0, arguments);
                } : e[t] = new Object(), e[t];
              }, window);
            } catch (e) {}
          }
        }, window.addEventListener("message", function (e) {
          l.receiveMessage(e);
        }, !1), r);
      });

      function s(e) {
        return e.useMobileCall || e.requestMethod && "mobilecall" == e.requestMethod ? (s = e, new Promise(function (n, r) {
          var e = "",
              t = s.data ? s.data : "";
          c.isEmpty(s.params) || (e = c.objToParamStr(s.params));
          var o = s.baseURL + s.url;
          c.isEmpty(s.params) || (o = o + "?" + e);
          var i = {
            url: o,
            method: s.method,
            timeout: s.timeout
          };
          c.isEmpty(t) || "object" === l(i.param = t) && (i.param = JSON.stringify(t)), c.isEmpty(s.headers) || (i.header = {}, c.forEach(s.headers, function (e) {
            i.header[Object.keys(e)[0]] = e[Object.keys(e)[0]];
          })), g.mobileCall(186, i, function (e) {
            var t = {
              data: e.data,
              config: s,
              verify: e.verify || null,
              resHeaders: e.resHeaders || null,
              time: e.time || 0
            };

            if (e && 1 == e.status) {
              if (e && e.verify && 0 == e.verify.status && s.kgAntiBushErrFun) if ((g.isKugouAndroid || g.isAndroid) && e.resHeaders) {
                if (e.resHeaders["SSA-CODE"] || e.resHeaders["ssa-code"]) return s.kgAntiBushErrFun && s.kgAntiBushErrFun(), s.kgAntiBushErrorReject && r(u("client verify Error: 0", s, null, null, null)), null;
              } else if (e.resHeaders["SSA-CODE"] || e.resHeaders["ssa-code"]) return s.kgAntiBushErrFun && s.kgAntiBushErrFun(), s.kgAntiBushErrorReject && r(u("client verify Error: 0", s, null, null, null)), null;
              n(t);
            } else {
              if (e && e.errno && 30021 == e.errno && s.kgAntiBushErrFun) return s.kgAntiBushErrFun && s.kgAntiBushErrFun(), s.kgAntiBushErrorReject && r(u("client verify Error: 0", s, null, null, null)), null;
              r(u("Request Error: " + e.errno, s, e.errno, null, null));
            }
          });
        }).then(function (e) {
          return e;
        }, function (e) {
          return Promise.reject(e);
        })) : e.requestMethod && "miniapp" == e.requestMethod ? (a = e, new Promise(function (n, t) {
          var e = "",
              r = a.data ? a.data : "";
          c.isEmpty(a.params) || (e = c.objToParamStr(a.params));
          var o = a.baseURL + a.url;
          c.isEmpty(a.params) || (o = o + "?" + e);
          var i = {
            url: o,
            method: a.method,
            timeout: a.timeout
          };
          c.isEmpty(r) || "object" === l(i.data = r) && (i.data = JSON.stringify(r)), c.isEmpty(a.headers) || (i.header = {}, c.forEach(a.headers, function (e) {
            i.header[Object.keys(e)[0]] = e[Object.keys(e)[0]];
          })), i.dataType = a.dataType || "json", i.success = function (e) {
            var t = {
              data: e.data,
              statusCode: e.statusCode,
              responseHeader: e.header,
              config: a
            };
            n(t);
          }, i.fail = function (e) {
            t(u(e.errMsg, a, e.errCode, null, null));
          }, window.MiniApp && window.MiniApp.request(i);
        }).then(function (e) {
          return e;
        }, function (e) {
          return Promise.reject(e);
        })) : o(e).then(function (e) {
          return e;
        }, function (e) {
          return Promise.reject(e);
        });
        var a, s;
      }

      function d(n) {
        return new Promise(function (e, t) {
          if (n.isAllowKGAntiBush) {
            if (n.kgAntiBushURL = n.kgAntiBushURL ? n.kgAntiBushURL : window.location.href, n.kgAntiBushAppid = n.kgAntiBushAppid ? n.kgAntiBushAppid : n.params.appid ? n.params.appid : "", n.kgAntiBushMid = n.kgAntiBushMid ? n.kgAntiBushMid : n.params.mid ? n.params.mid : "", n.kgAntiBushUserid = n.kgAntiBushUserid ? n.kgAntiBushUserid : n.params.userid ? n.params.userid : 0, c.isEmpty(n.kgAntiBushAppid)) return console.error("使用了 isAllowKGAntiBush=true，但是没有传 appid"), t(n), null;
            if (c.isEmpty(n.kgAntiBushMid)) return console.error("使用了 isAllowKGAntiBush=true，但是没有传 mid"), t(n), null;
            e(n);
          } else e(n);
        });
      }

      var f = {
        url: "",
        baseURL: "",
        retryURL: "",
        isGateway: !0,
        gatewayURL: "",
        retry: 1,
        timeout: 15e3,
        params: null,
        data: null,
        method: "get",
        async: !0,
        useMobileCall: !1,
        kgAntiBushUrl: window.location.href,
        isAllowKGAntiBush: !0,
        kgAntiBushURL: "",
        kgAntiBushAppid: "",
        kgAntiBushMid: "",
        kgAntiBushUserid: "",
        sign: "",
        signSalt: "",
        isAllowSign: !0
      };

      function p(e) {
        this.requestConfig = e, this.interceptors = {
          request: new r(),
          response: new r()
        };
      }

      p.prototype.request = function (e) {
        e = function (e) {
          e = e || {};
          var t = {};
          if ((t = c.deepMerge(f, e)).headers = t.headers ? t.headers : [], t.url = c.trim(t.url), c.isEmpty(t.url) || 0 == t.url.indexOf("/") || (t.url = "/" + t.url), t.baseURL = c.trim(t.baseURL), c.isEmpty(t.baseURL) || "/" !== t.baseURL.charAt(t.baseURL.length - 1) || (t.baseURL = t.baseURL.substring(0, t.baseURL.length - 1)), t.gatewayURL = c.trim(t.gatewayURL), c.isEmpty(t.gatewayURL) || "/" !== t.gatewayURL.charAt(t.gatewayURL.length - 1) || (t.gatewayURL = t.gatewayURL.substring(0, t.gatewayURL.length - 1)), t.retryURL = c.trim(t.retryURL), c.isEmpty(t.retryURL) && (t.retryURL = t.baseURL), c.isEmpty(t.retryURL) || "/" !== t.retryURL.charAt(t.retryURL.length - 1) || (t.retryURL = t.retryURL.substring(0, t.retryURL.length - 1)), t.isGateway = !0 === t.isGateway, t.gatewayURL = t.gatewayURL ? t.gatewayURL : t.baseURL, t.isGateway && c.isEmpty(t.gatewayURL)) return console.error("如果要使用 gateway 请求，请传入正确的 gatewayURL 或者 baseURL"), null;

          if (t.isGateway && !c.isEmpty(t.gatewayURL)) {
            var n = t.gatewayURL.replace(/https:\/\/|http:\/\//gi, ""),
                r = new Array();
            c.forEach(t.headers, function (e) {
              "x-router" in e || r.push(e);
            }), t.headers = r;
            var o = n.replace(".kugou.com", "");
            t.baseURL = "https://gateway.kugou.com/".concat(o), t.retryURL = "https://gatewayretry.kugou.com/".concat(o);
          }

          return t.timeout = t.timeout ? t.timeout : 5e3, t.retry = t.retry, t.data = t.data ? t.data : "", "{}" == JSON.stringify(t.data) && (t.data = null), t.method = t.method ? t.method : "get", t.method = t.method.toLowerCase(), t.async = !0 === t.async, t.useMobileCall = !0 === t.useMobileCall, c.isEmpty(t.withCredentials) || (t.withCredentials = !0 === t.withCredentials), t.isAllowKGAntiBush = !0 === t.isAllowKGAntiBush, t && t.useMobileCall && (t.kgAntiBushErrFun = t.kgAntiBushErrFun || function () {
            c.toast({
              message: "操作过于频繁，请稍后再试",
              duration: "2000"
            });
          }), t;
        }((this.requestConfig, e));

        var t = Promise.resolve(e),
            n = new Array();

        for (this.interceptors.request.forEach(function (e) {
          n.unshift(e.fulfilled, e.rejected);
        }), n.push(d, void 0), n.push(s, void 0), this.interceptors.response.forEach(function (e) {
          n.push(e.fulfilled, e.rejected);
        }); n.length;) {
          t = t.then(n.shift(), n.shift());
        }

        return t;
      };

      var h,
          y,
          v = e(function (e) {
        function d(e, t) {
          var n = (65535 & e) + (65535 & t);
          return (e >> 16) + (t >> 16) + (n >> 16) << 16 | 65535 & n;
        }

        function s(e, t, n, r, o, i) {
          return d((a = d(d(t, e), d(r, i))) << (s = o) | a >>> 32 - s, n);
          var a, s;
        }

        function f(e, t, n, r, o, i, a) {
          return s(t & n | ~t & r, e, t, o, i, a);
        }

        function p(e, t, n, r, o, i, a) {
          return s(t & r | n & ~r, e, t, o, i, a);
        }

        function m(e, t, n, r, o, i, a) {
          return s(t ^ n ^ r, e, t, o, i, a);
        }

        function g(e, t, n, r, o, i, a) {
          return s(n ^ (t | ~r), e, t, o, i, a);
        }

        function l(e, t) {
          var n, r, o, i, a;
          e[t >> 5] |= 128 << t % 32, e[14 + (t + 64 >>> 9 << 4)] = t;
          var s = 1732584193,
              l = -271733879,
              c = -1732584194,
              u = 271733878;

          for (n = 0; n < e.length; n += 16) {
            s = f(r = s, o = l, i = c, a = u, e[n], 7, -680876936), u = f(u, s, l, c, e[n + 1], 12, -389564586), c = f(c, u, s, l, e[n + 2], 17, 606105819), l = f(l, c, u, s, e[n + 3], 22, -1044525330), s = f(s, l, c, u, e[n + 4], 7, -176418897), u = f(u, s, l, c, e[n + 5], 12, 1200080426), c = f(c, u, s, l, e[n + 6], 17, -1473231341), l = f(l, c, u, s, e[n + 7], 22, -45705983), s = f(s, l, c, u, e[n + 8], 7, 1770035416), u = f(u, s, l, c, e[n + 9], 12, -1958414417), c = f(c, u, s, l, e[n + 10], 17, -42063), l = f(l, c, u, s, e[n + 11], 22, -1990404162), s = f(s, l, c, u, e[n + 12], 7, 1804603682), u = f(u, s, l, c, e[n + 13], 12, -40341101), c = f(c, u, s, l, e[n + 14], 17, -1502002290), s = p(s, l = f(l, c, u, s, e[n + 15], 22, 1236535329), c, u, e[n + 1], 5, -165796510), u = p(u, s, l, c, e[n + 6], 9, -1069501632), c = p(c, u, s, l, e[n + 11], 14, 643717713), l = p(l, c, u, s, e[n], 20, -373897302), s = p(s, l, c, u, e[n + 5], 5, -701558691), u = p(u, s, l, c, e[n + 10], 9, 38016083), c = p(c, u, s, l, e[n + 15], 14, -660478335), l = p(l, c, u, s, e[n + 4], 20, -405537848), s = p(s, l, c, u, e[n + 9], 5, 568446438), u = p(u, s, l, c, e[n + 14], 9, -1019803690), c = p(c, u, s, l, e[n + 3], 14, -187363961), l = p(l, c, u, s, e[n + 8], 20, 1163531501), s = p(s, l, c, u, e[n + 13], 5, -1444681467), u = p(u, s, l, c, e[n + 2], 9, -51403784), c = p(c, u, s, l, e[n + 7], 14, 1735328473), s = m(s, l = p(l, c, u, s, e[n + 12], 20, -1926607734), c, u, e[n + 5], 4, -378558), u = m(u, s, l, c, e[n + 8], 11, -2022574463), c = m(c, u, s, l, e[n + 11], 16, 1839030562), l = m(l, c, u, s, e[n + 14], 23, -35309556), s = m(s, l, c, u, e[n + 1], 4, -1530992060), u = m(u, s, l, c, e[n + 4], 11, 1272893353), c = m(c, u, s, l, e[n + 7], 16, -155497632), l = m(l, c, u, s, e[n + 10], 23, -1094730640), s = m(s, l, c, u, e[n + 13], 4, 681279174), u = m(u, s, l, c, e[n], 11, -358537222), c = m(c, u, s, l, e[n + 3], 16, -722521979), l = m(l, c, u, s, e[n + 6], 23, 76029189), s = m(s, l, c, u, e[n + 9], 4, -640364487), u = m(u, s, l, c, e[n + 12], 11, -421815835), c = m(c, u, s, l, e[n + 15], 16, 530742520), s = g(s, l = m(l, c, u, s, e[n + 2], 23, -995338651), c, u, e[n], 6, -198630844), u = g(u, s, l, c, e[n + 7], 10, 1126891415), c = g(c, u, s, l, e[n + 14], 15, -1416354905), l = g(l, c, u, s, e[n + 5], 21, -57434055), s = g(s, l, c, u, e[n + 12], 6, 1700485571), u = g(u, s, l, c, e[n + 3], 10, -1894986606), c = g(c, u, s, l, e[n + 10], 15, -1051523), l = g(l, c, u, s, e[n + 1], 21, -2054922799), s = g(s, l, c, u, e[n + 8], 6, 1873313359), u = g(u, s, l, c, e[n + 15], 10, -30611744), c = g(c, u, s, l, e[n + 6], 15, -1560198380), l = g(l, c, u, s, e[n + 13], 21, 1309151649), s = g(s, l, c, u, e[n + 4], 6, -145523070), u = g(u, s, l, c, e[n + 11], 10, -1120210379), c = g(c, u, s, l, e[n + 2], 15, 718787259), l = g(l, c, u, s, e[n + 9], 21, -343485551), s = d(s, r), l = d(l, o), c = d(c, i), u = d(u, a);
          }

          return [s, l, c, u];
        }

        function c(e) {
          var t,
              n = "",
              r = 32 * e.length;

          for (t = 0; t < r; t += 8) {
            n += String.fromCharCode(e[t >> 5] >>> t % 32 & 255);
          }

          return n;
        }

        function u(e) {
          var t,
              n = [];

          for (n[(e.length >> 2) - 1] = void 0, t = 0; t < n.length; t += 1) {
            n[t] = 0;
          }

          var r = 8 * e.length;

          for (t = 0; t < r; t += 8) {
            n[t >> 5] |= (255 & e.charCodeAt(t / 8)) << t % 32;
          }

          return n;
        }

        function r(e) {
          var t,
              n,
              r = "0123456789abcdef",
              o = "";

          for (n = 0; n < e.length; n += 1) {
            t = e.charCodeAt(n), o += r.charAt(t >>> 4 & 15) + r.charAt(15 & t);
          }

          return o;
        }

        function n(e) {
          return unescape(encodeURIComponent(e));
        }

        function o(e) {
          return c(l(u(t = n(e)), 8 * t.length));
          var t;
        }

        function i(e, t) {
          return function (e, t) {
            var n,
                r,
                o = u(e),
                i = [],
                a = [];

            for (i[15] = a[15] = void 0, 16 < o.length && (o = l(o, 8 * e.length)), n = 0; n < 16; n += 1) {
              i[n] = 909522486 ^ o[n], a[n] = 1549556828 ^ o[n];
            }

            return r = l(i.concat(u(t)), 512 + 8 * t.length), c(l(a.concat(r), 640));
          }(n(e), n(t));
        }

        function t(e, t, n) {
          return t ? n ? i(t, e) : r(i(t, e)) : n ? o(e) : r(o(e));
        }

        var a;
        a = b, e.exports ? e.exports = t : a.md5 = t;
      }),
          k = e(function (e, t) {
        var l, i;
        e.exports = (l = {
          Cookie: {
            write: function write(e, t, n, r, o, i) {
              /^\w*$/.test(e) || alert("cookie格式不正确"), /; /.test(t) && alert("cookie格式不正确");
              var a = e + "=" + t;

              if (n) {
                var s = new Date();
                s.setTime(s.getTime() + 1e3 * n), a += "; expires=" + s.toGMTString();
              }

              r && (a += "; path=" + r), o && (a += "; domain=" + o), i && (a += "; secure"), document.cookie = a;
            },
            rewriteKey: function rewriteKey(e, t, n, r, o, i, a) {
              var s = t;

              if (n) {
                var l = this.read(e),
                    c = new RegExp("\\b" + t + "=([^&]*)\\b", "g");
                s = l.replace(c, function (e, t) {
                  return e.replace(t, n);
                });
              }

              /^\d+(s|m|h|d)$/i.test(r) ? (/^\d+s$/i.test(r) && this.setSec(e, s, r.replace(/s$/i, ""), o, i, a), /^\d+m$/i.test(r) && this.setMin(e, s, r.replace(/m$/i, ""), o, i, a), /^\d+h$/i.test(r) && this.setHour(e, s, r.replace(/h$/i, ""), o, i, a), /^\d+d$/i.test(r) && this.setDay(e, s, r.replace(/d$/i, ""), o, i, a)) : this.write(e, s, r, o, i, a);
            },
            setDay: function setDay(e, t, n, r, o, i) {
              this.write(e, t, 24 * n * 60 * 60, r, o, i);
            },
            setHour: function setHour(e, t, n, r, o, i) {
              this.write(e, t, 60 * n * 60, r, o, i);
            },
            setMin: function setMin(e, t, n, r, o, i) {
              this.write(e, t, 60 * n, r, o, i);
            },
            setSec: function setSec(e, t, n, r, o, i) {
              this.write(e, t, n, r, o, i);
            },
            read: function read(e, t, n) {
              for (var r = "", o = document.cookie.split("; "), i = 0; i < o.length; i++) {
                var a = o[i].match(/^(\w+)=(.+)$/);

                if (a && 1 < a.length && a[1] == e) {
                  r = a[2];
                  break;
                }
              }

              return "" == r ? null : t ? n ? JSON.parse(r)[t] : new l.Param().parse(r)[t] : r;
            },
            remove: function remove(e, t, n) {
              var r = e + "=";
              t && (r += "; path=" + t), n && (r += ";domain=" + n), r += "; expires=Fri, 02-Jan-1970 00:00:00 GMT", document.cookie = r;
            }
          },
          Md5: function Md5(e) {
            function s(e, t, n, r, o, i) {
              return g((a = g(g(t, e), g(r, i))) << (s = o) | a >>> 32 - s, n);
              var a, s;
            }

            function d(e, t, n, r, o, i, a) {
              return s(t & n | ~t & r, e, t, o, i, a);
            }

            function f(e, t, n, r, o, i, a) {
              return s(t & r | n & ~r, e, t, o, i, a);
            }

            function p(e, t, n, r, o, i, a) {
              return s(t ^ n ^ r, e, t, o, i, a);
            }

            function m(e, t, n, r, o, i, a) {
              return s(n ^ (t | ~r), e, t, o, i, a);
            }

            function g(e, t) {
              var n = (65535 & e) + (65535 & t);
              return (e >> 16) + (t >> 16) + (n >> 16) << 16 | 65535 & n;
            }

            var t;
            return e ? function (e) {
              for (var t = "", n = 0; n < 4 * e.length; n++) {
                t += "0123456789abcdef".charAt(e[n >> 2] >> n % 4 * 8 + 4 & 15) + "0123456789abcdef".charAt(e[n >> 2] >> n % 4 * 8 & 15);
              }

              return t;
            }(function (e, t) {
              e[t >> 5] |= 128 << t % 32, e[14 + (t + 64 >>> 9 << 4)] = t;

              for (var n = 1732584193, r = -271733879, o = -1732584194, i = 271733878, a = 0; a < e.length; a += 16) {
                var s = n,
                    l = r,
                    c = o,
                    u = i;
                r = m(r = m(r = m(r = m(r = p(r = p(r = p(r = p(r = f(r = f(r = f(r = f(r = d(r = d(r = d(r = d(r, o = d(o, i = d(i, n = d(n, r, o, i, e[a + 0], 7, -680876936), r, o, e[a + 1], 12, -389564586), n, r, e[a + 2], 17, 606105819), i, n, e[a + 3], 22, -1044525330), o = d(o, i = d(i, n = d(n, r, o, i, e[a + 4], 7, -176418897), r, o, e[a + 5], 12, 1200080426), n, r, e[a + 6], 17, -1473231341), i, n, e[a + 7], 22, -45705983), o = d(o, i = d(i, n = d(n, r, o, i, e[a + 8], 7, 1770035416), r, o, e[a + 9], 12, -1958414417), n, r, e[a + 10], 17, -42063), i, n, e[a + 11], 22, -1990404162), o = d(o, i = d(i, n = d(n, r, o, i, e[a + 12], 7, 1804603682), r, o, e[a + 13], 12, -40341101), n, r, e[a + 14], 17, -1502002290), i, n, e[a + 15], 22, 1236535329), o = f(o, i = f(i, n = f(n, r, o, i, e[a + 1], 5, -165796510), r, o, e[a + 6], 9, -1069501632), n, r, e[a + 11], 14, 643717713), i, n, e[a + 0], 20, -373897302), o = f(o, i = f(i, n = f(n, r, o, i, e[a + 5], 5, -701558691), r, o, e[a + 10], 9, 38016083), n, r, e[a + 15], 14, -660478335), i, n, e[a + 4], 20, -405537848), o = f(o, i = f(i, n = f(n, r, o, i, e[a + 9], 5, 568446438), r, o, e[a + 14], 9, -1019803690), n, r, e[a + 3], 14, -187363961), i, n, e[a + 8], 20, 1163531501), o = f(o, i = f(i, n = f(n, r, o, i, e[a + 13], 5, -1444681467), r, o, e[a + 2], 9, -51403784), n, r, e[a + 7], 14, 1735328473), i, n, e[a + 12], 20, -1926607734), o = p(o, i = p(i, n = p(n, r, o, i, e[a + 5], 4, -378558), r, o, e[a + 8], 11, -2022574463), n, r, e[a + 11], 16, 1839030562), i, n, e[a + 14], 23, -35309556), o = p(o, i = p(i, n = p(n, r, o, i, e[a + 1], 4, -1530992060), r, o, e[a + 4], 11, 1272893353), n, r, e[a + 7], 16, -155497632), i, n, e[a + 10], 23, -1094730640), o = p(o, i = p(i, n = p(n, r, o, i, e[a + 13], 4, 681279174), r, o, e[a + 0], 11, -358537222), n, r, e[a + 3], 16, -722521979), i, n, e[a + 6], 23, 76029189), o = p(o, i = p(i, n = p(n, r, o, i, e[a + 9], 4, -640364487), r, o, e[a + 12], 11, -421815835), n, r, e[a + 15], 16, 530742520), i, n, e[a + 2], 23, -995338651), o = m(o, i = m(i, n = m(n, r, o, i, e[a + 0], 6, -198630844), r, o, e[a + 7], 10, 1126891415), n, r, e[a + 14], 15, -1416354905), i, n, e[a + 5], 21, -57434055), o = m(o, i = m(i, n = m(n, r, o, i, e[a + 12], 6, 1700485571), r, o, e[a + 3], 10, -1894986606), n, r, e[a + 10], 15, -1051523), i, n, e[a + 1], 21, -2054922799), o = m(o, i = m(i, n = m(n, r, o, i, e[a + 8], 6, 1873313359), r, o, e[a + 15], 10, -30611744), n, r, e[a + 6], 15, -1560198380), i, n, e[a + 13], 21, 1309151649), o = m(o, i = m(i, n = m(n, r, o, i, e[a + 4], 6, -145523070), r, o, e[a + 11], 10, -1120210379), n, r, e[a + 2], 15, 718787259), i, n, e[a + 9], 21, -343485551), n = g(n, s), r = g(r, l), o = g(o, c), i = g(i, u);
              }

              return Array(n, r, o, i);
            }(function (e) {
              for (var t = Array(), n = 0; n < 8 * e.length; n += 8) {
                t[n >> 5] |= (255 & e.charCodeAt(n / 8)) << n % 32;
              }

              return t;
            }(t = e), 8 * t.length)) : "";
          },
          Param: function Param() {
            var r = [],
                i = {};
            this.parse = function (e) {
              for (var t = e.split("&"), n = 0, r = t.length; n < r; n++) {
                var o = t[n].split("=");
                i[o[0]] = o[1];
              }

              return i;
            }, this.toString = function (e) {
              return e = e || "&", r.join(e);
            }, this.add = function (e, t) {
              var n = e + "=" + t;
              return r.push(n), this;
            };
          },
          IsEmpty: function IsEmpty(e) {
            return void 0 === e || null == e || "" == e;
          },
          Guid: function Guid() {
            function e() {
              return (65536 * (1 + Math.random()) | 0).toString(16).substring(1);
            }

            return e() + e() + "-" + e() + "-" + e() + "-" + e() + "-" + e() + e() + e();
          },
          getKgMid: function getKgMid() {
            var e = l.Cookie.read("kg_mid");

            if (navigator.cookieEnabled) {
              if (l.IsEmpty(e)) {
                var t = l.Guid();
                e = l.Md5(t);

                try {
                  l.Cookie.write("kg_mid", l.Md5(t), 864e6, "/", "kugou.com");
                } catch (e) {}
              }
            } else {
              var n = navigator.userAgent,
                  r = function () {
                var e = navigator.plugins,
                    t = "";

                if (0 < e.length) {
                  for (var n = [], r = 0, o = e.length; r < o; r++) {
                    var i = e[r].name;
                    n.push(i);
                  }

                  t = n.toString();
                }

                return t;
              }(),
                  o = screen.width + "x" + screen.height,
                  i = screen.colorDepth ? screen.colorDepth : "",
                  a = screen.pixelDepth ? screen.pixelDepth : "",
                  s = function () {
                var e = ["canvas"];

                try {
                  var t = document.createElement("canvas");

                  if (t.getContext && t.getContext("2d")) {
                    t.width = 200, t.height = 200, t.style.display = "inline";
                    var n = t.getContext("2d");
                    n.rect(0, 0, 10, 10), n.rect(2, 2, 6, 6), e.push("canvas winding:" + (!1 === n.isPointInPath(5, 5, "evenodd") ? "yes" : "no")), n.textBaseline = "alphabetic", n.fillStyle = "#f60", n.fillRect(125, 1, 62, 20), n.fillStyle = "#069", n.font = "14px 'Arial'", n.fillText("hello kugou", 2, 15), n.fillStyle = "rgba(102, 204, 0, 0.2)", n.font = "18pt Arial", n.fillText("hello kugou", 4, 45), n.globalCompositeOperation = "multiply", n.fillStyle = "rgb(255,0,255)", n.beginPath(), n.arc(50, 50, 50, 0, 2 * Math.PI, !0), n.closePath(), n.fill(), n.fillStyle = "rgb(0,255,255)", n.beginPath(), n.arc(100, 50, 50, 0, 2 * Math.PI, !0), n.closePath(), n.fill(), n.fillStyle = "rgb(255,255,0)", n.beginPath(), n.arc(75, 100, 50, 0, 2 * Math.PI, !0), n.closePath(), n.fill(), n.fillStyle = "rgb(255,0,255)", n.arc(75, 75, 75, 0, 2 * Math.PI, !0), n.arc(75, 75, 25, 0, 2 * Math.PI, !0), n.fill("evenodd"), t.toDataURL && e.push("canvas fp:" + t.toDataURL());
                  }
                } catch (e) {}

                return l.Md5(e.toString());
              }();

              e = l.Md5(n + r + o + i + a + s);
            }

            return e;
          },
          isiOS: function isiOS() {
            var e = navigator.userAgent,
                t = e.match(/(iPad).*OS\s([\d_]+)/),
                n = e.match(/(iPod)(.*OS\s([\d_]+))?/),
                r = !t && e.match(/(iPhone\sOS)\s([\d_]+)/);
            return !!(t || n || r);
          }
        }, i = function (e) {
          return t = e = {
            exports: {}
          }, function () {
            var g, e;
            t.exports = (g = {
              str2Json: function str2Json(e) {
                var t = {};
                if ("[object String]" === Object.prototype.toString.call(e)) try {
                  t = JSON.parse(e);
                } catch (e) {
                  t = {};
                }
                return t;
              },
              json2Str: function json2Str(e) {
                var t = e;
                if ("string" != typeof e) try {
                  t = JSON.stringify(e);
                } catch (e) {
                  t = "";
                }
                return t;
              },
              cbNum: 0,
              isIOS: !!navigator.userAgent.match(/KGBrowser/gi),
              isKugouAndroid: !!navigator.userAgent.match(/kugouandroid/gi),
              isAndroid: "undefined" != typeof external && void 0 !== external.superCall,
              isFXAPP: !!navigator.userAgent.match(/Fanxing/gi),
              isFXQianBanAPP: !!navigator.userAgent.match(/QianBan/gi),
              isIframePage: window.parent && window.parent != window,
              loadUrl: function loadUrl(e) {
                var t = document.createElement("iframe");
                t.setAttribute("src", e), t.setAttribute("style", "display:none;"), t.setAttribute("height", "0px"), t.setAttribute("width", "0px"), t.setAttribute("frameborder", "0"), document.body.appendChild(t), t.parentNode.removeChild(t), t = null;
              },
              mobileCallInIframe: function mobileCallInIframe(e, t, n) {
                var r = {
                  type: "KgMobileCall",
                  cmd: e
                };
                t && (r.dataJson = t), n && (r.cbName = n), r.source = "personal", window.parent.postMessage(r, "*");
              },
              receiveMessage: function receiveMessage(e) {
                var t = e.data;

                if ("KgMobileCall" == t.type && window[t.cbName] && (t.dataJson ? window[t.cbName](t.dataJson) : window[t.cbName](), window[t.cbName] = null), "KgWebMobileCall" == t.type) {
                  var n = t.funcName.split(".");
                  KgWebMobileCall[n[1]] && (t.dataJson ? KgWebMobileCall[n[1]](t.dataJson) : KgWebMobileCall[n[1]]());
                }
              },
              callCmd: function callCmd(n) {
                var r = g;

                if (r.isKugouAndroid) {
                  var e = {},
                      t = "";

                  if (n.cmd && (e.cmd = n.cmd), n.jsonStr && (e.jsonStr = n.jsonStr), n.callback && (r.cbNum++, t = "kgandroidmobilecall_" + (n.cmd || 0) + "_" + r.cbNum + Math.random().toString().substr(2, 9), e.callback = t, window[t] = function (e, t) {
                    void 0 !== e && ("[object String]" === Object.prototype.toString.call(e) ? (e = "#" === t ? decodeURIComponent(e) : decodeURIComponent(decodeURIComponent(e)), n.callback(r.str2Json(e))) : n.callback(e));
                  }), n.AndroidCallback) {
                    var o = r.str2Json(n.jsonStr);
                    o.AndroidCallback = t, n.jsonStr = r.json2Str(o), n.jsonStr && (e.jsonStr = n.jsonStr);
                  }

                  var i = encodeURIComponent(JSON.stringify(e)),
                      a = "kugoujsbridge://start.kugou_jsbridge/?".concat(i);
                  r.isIframePage ? r.mobileCallInIframe(e.cmd, e.jsonStr, t) : r.loadUrl(a);
                } else if (r.isAndroid) {
                  var s = "",
                      l = "";

                  if (n.jsonStr) {
                    if (n.callback && "" !== n.callback && !0 === n.AndroidCallback) {
                      r.cbNum++, l = "kgmobilecall_" + (n.cmd || 0) + "_" + r.cbNum + Math.random().toString().substr(2, 9), window[l] = function (e, t) {
                        void 0 !== e && ("[object String]" === Object.prototype.toString.call(e) ? (e = "#" === t ? decodeURIComponent(e) : decodeURIComponent(decodeURIComponent(e)), n.callback(r.str2Json(e))) : n.callback(e));
                      };
                      var c = r.str2Json(n.jsonStr);
                      c.AndroidCallback = l, n.jsonStr = r.json2Str(c);
                    }

                    if (r.isIframePage && n.AndroidCallback) r.mobileCallInIframe(n.cmd, n.jsonStr, l);else try {
                      s = external.superCall(n.cmd, n.jsonStr);
                    } catch (e) {}
                  } else try {
                    s = external.superCall(n.cmd);
                  } catch (e) {}

                  (!r.isIframePage || r.isIframePage && !n.AndroidCallback) && n.callback && "" !== n.callback && "AndroidCallback" != s && (s = r.str2Json(s), n.callback(s));
                } else if (r.isFXAPP || r.isFXQianBanAPP) {
                  var u = "",
                      d = "";
                  if (u = n.callback ? (r.cbNum++, d = "kgmobilecall_" + (n.cmd || 0) + "_" + r.cbNum + Math.random().toString().substr(2, 9), window[d] = function (e) {
                    void 0 !== e && n.callback && ("[object String]" === Object.prototype.toString.call(e) ? n.callback(r.str2Json(e)) : n.callback(e));
                  }, n.jsonStr ? 'fanxing2://send.message/?{"cmd":' + n.cmd + ', "jsonStr":' + n.jsonStr + ', "callback":"' + d + '"}' : 'fanxing2://send.message/?{"cmd":' + n.cmd + ', "callback":"' + d + '"}') : n.jsonStr ? 'fanxing2://send.message/?{"cmd":' + n.cmd + ', "jsonStr":' + n.jsonStr + "}" : 'fanxing2://send.message/?{"cmd":' + n.cmd + "}", r.isIframePage) r.mobileCallInIframe(n.cmd, n.jsonStr, d);else if (navigator.userAgent.match(/(Android);?[\s\/]+([\d.]+)?/)) {
                    if (external && external.callFanxing) {
                      var f = {
                        cmd: n.cmd,
                        jsonStr: n.jsonStr || "",
                        callback: d
                      };
                      external.callFanxing(JSON.stringify(f));
                    } else window.prompt(u);
                  } else r.loadUrl(u);
                } else {
                  var p = "",
                      m = "";
                  n.callback && (r.cbNum++, m = "kgmobilecall_" + (n.cmd || 0) + "_" + r.cbNum + Math.random().toString().substr(2, 9), window[m] = function (e) {
                    void 0 !== e && n.callback && ("[object String]" === Object.prototype.toString.call(e) ? n.callback(r.str2Json(e)) : n.callback(e));
                  }), m && "" != m && n.jsonStr && (p = 'kugouurl://start.music/?{"cmd":' + n.cmd + ', "jsonStr":' + n.jsonStr + ', "callback":"' + m + '"}'), m && "" != m && !n.jsonStr && (p = 'kugouurl://start.music/?{"cmd":' + n.cmd + ', "callback":"' + m + '"}'), "" == m && n.jsonStr && (p = 'kugouurl://start.music/?{"cmd":' + n.cmd + ', "jsonStr":' + n.jsonStr + "}"), "" != m || n.jsonStr || (p = 'kugouurl://start.music/?{"cmd":' + n.cmd + "}"), r.isIframePage ? r.mobileCallInIframe(n.cmd, n.jsonStr, m) : r.loadUrl(p);
                }
              }
            }, e = {
              isIOS: g.isIOS,
              isKugouAndroid: g.isKugouAndroid,
              isAndroid: g.isAndroid,
              isFXAPP: g.isFXAPP,
              isFXQianBanAPP: g.isFXQianBanAPP,
              isInClient: function isInClient() {
                return !!(g.isAndroid || g.isKugouAndroid || g.isIOS || g.isFXAPP || g.isFXQianBanAPP);
              },
              mobileCall: function mobileCall(e, t, n) {
                var r = "";
                if (t && (r = g.json2Str(t)), !e) return console.error("请输入命令号！"), !1;
                var o = {};
                e && (o.cmd = e), "" != r && (o.jsonStr = r), n && (o.callback = n), !e || 186 != e && 225 != e || n && (o.AndroidCallback = !0), g.callCmd(o);
              },
              KgWebMobileCall: function KgWebMobileCall(r, o) {
                if (r) try {
                  g.isIframePage && window.parent.postMessage({
                    type: "KgWebMobileCall",
                    funcName: r
                  }, "*");
                  var i = r.split(".");
                  i.reduce(function (e, t) {
                    if (e[t]) {
                      if (t !== i[i.length - 1]) return e[t];
                      var n = e[t];
                      return "function" == typeof n ? (e[t] = function () {
                        n && n.apply(void 0, arguments), o && o.apply(void 0, arguments);
                      }, e[t]) : (console.error("请检查，当前环境变量已注册了对象：" + r + "，且该对象不是方法"), null);
                    }

                    return t === i[i.length - 1] ? e[t] = function () {
                      o && o.apply(void 0, arguments);
                    } : e[t] = new Object(), e[t];
                  }, window);
                } catch (e) {}
              }
            }, window.addEventListener("message", function (e) {
              g.receiveMessage(e);
            }, !1), e);
          }(), e.exports;
          var t;
        }(), function (e, n) {
          var t = {
            getUserInfo: 101,
            getVersion: 122,
            getMobileInfo: 124
          },
              r = {
            appid: null,
            mid: null,
            uuid: null,
            plat: null,
            dfid: null,
            userid: null,
            userpic: null,
            userNickName: null,
            token: null,
            clientver: null
          };
          if (i.isInClient() && !i.isFXAP) i.mobileCall(t.getUserInfo, null, function (e) {
            1 == e.status ? (r.userid = e.kugouID, r.token = e.token, r.userpic = e.photo, r.userNickName = e.nickName, r.isVIP = e.isVIP || e.isVip) : (r.userid = null, r.token = null, r.userpic = null, r.userNickName = null), r.appid = e.appid, i.mobileCall(t.getVersion, null, function (e) {
              r.clientver = e.version, i.mobileCall(t.getMobileInfo, null, function (e) {
                r.mid = e.mid_v2 ? e.mid_v2 : e.mid, r.dfid = e.dfid ? e.dfid : "-", r.uuid = e.uuid ? e.uuid : r.mid, r.osVersion = e.osVersion ? e.osVersion : "", i.isIOS ? r.plat = 2 : r.plat = 1, n && n(r);
              });
            });
          });else if (i.isInClient() && i.isFXAP) i.mobileCall(625, null, function (e) {
            var t = JSON.parse(e.jsonStr);
            r.clientver = t.version, r.mid = t.mid, r.uuid = t.uuid ? t.uuid : r.mid, r.dfid = t.dfid ? t.dfid : "-", r.appid = t.appId, l.isiOS() ? r.plat = 2 : r.plat = 1, i.mobileCall(410, null, function (e) {
              1 == JSON.parse(e.jsonStr).status ? i.mobileCall(411, {}, function (e) {
                var t = JSON.parse(e.jsonStr).jsonStr ? JSON.parse(e.jsonStr).jsonStr : JSON.parse(e.jsonStr);
                r.userid = t.kugouId, r.token = t.token, r.pic = t.userLogo, r.nickName = t.nickName, n && n(r);
              }) : (r.userid = null, r.token = null, r.userpic = null, r.userNickName = null, n && n(r));
            });
          });else {
            r.appid = e || null, r.mid = l.getKgMid(), r.uuid = r.mid, r.plat = 4, r.dfid = l.Cookie.read("kg_dfid") || "-", r.userid = l.Cookie.read("KuGoo", "KugooID"), r.userpic = l.Cookie.read("KuGoo", "Pic"), r.userNickName = l.Cookie.read("KuGoo", "NickName"), r.token = l.Cookie.read("KuGoo", "t");
            var o = l.Cookie.read("KuGoo", "a_id");
            o && o != r.appid && (r.userid = null, r.token = null, r.userpic = null, r.userNickName = null), r.clientver = 1e3, r.userNickName = r.userNickName ? unescape(r.userNickName) : "", n && n(r);
          }
        });
      });

      function j(e, t, n) {
        var a,
            s = 1 < arguments.length && void 0 !== t ? t : "",
            l = 2 < arguments.length && void 0 !== n ? n : {},
            r = !1,
            o = !1,
            c = "json",
            i = m({}, 0 < arguments.length && void 0 !== e ? e : {}),
            u = g.isInClient();
        "function" == typeof l ? a = l : (a = l.callback, r = l.useH5 || !1, c = l.postType || "json", o = l.isCDN || !1), !s || "[object Object]" == Object.prototype.toString.call(s) && "urlencoded" != c || (u = !1);

        function d(t) {
          var e = [],
              n = [],
              r = "NVPh5oo715z5DIWAeQlhMDsWXXQV4hwt";

          for (var o in l && l.appkey && (delete t.srcappid, r = l.appkey), t) {
            e.push(o);
          }

          if (e.sort(), e.forEach(function (e) {
            n.push(e + "=" + t[e]);
          }), s) if ("[object Object]" == Object.prototype.toString.call(s)) {
            if ("json" == c) n.push(JSON.stringify(s));else {
              var i = [];

              for (var o in s) {
                i.push(o + "=" + s[o]);
              }

              n.push(i.join("&"));
            }
          } else n.push(s);
          n.unshift(r), n.push(r), t.signature = v(n.join("")), l.log && (console.log("H5签名前参数排序结果", n), console.log("H5签名前md5原字符串", n.join("")), console.log("H5签名后返回", t)), s ? a && a(t, "[object Object]" == Object.prototype.toString.call(s) && "json" == c ? JSON.stringify(s) : s) : a && a(t);
        }

        function f() {
          var e = new Date().getTime();
          o && (delete t.clienttime, delete t.mid, delete t.uuid, delete t.dfid);
          var t = {
            srcappid: "2919",
            clientver: "20000",
            clienttime: e,
            mid: e,
            uuid: e,
            dfid: "-"
          };
          i && i.appid && i.clientver && i.mid && i.uuid && i.dfid ? (i.srcappid = "2919", i.clienttime = i.clienttime || e, d(i)) : k(1058, function (e) {
            t.appid = e.appid, t.clientver = e.clientver, t.mid = e.mid, t.uuid = e.uuid, t.dfid = e.dfid, i.appid || delete i.appid, i = m({}, t, {}, i), d(i);
          });
        }

        if (u && !r) {
          var p = !1;
          g.mobileCall(764, {
            get: i,
            post: s
          }, function (e) {
            return !p && (p = !0, e && e.status ? (delete e.status, l.log && (console.log("客户端签名前参数", {
              get: i,
              post: s
            }), console.log("客户端签名后返回", m({}, i, {}, e))), i = m({}, i, {}, e), s ? a && a(i, "[object Object]" == Object.prototype.toString.call(s) && "json" == c ? JSON.stringify(s) : s) : a && a(i), !1) : (u = !1, void f()));
          });
        } else u = !1, f();
      }

      return h = new p(f), y = p.prototype.request.bind(h), c.extend(y, p.prototype, h), c.extend(y, h), y.interceptors.request.on(function (n) {
        return new Promise(function (t) {
          var e = !1;
          "h5" == n.sign && (e = !0), n.isAllowSign ? "openapi" == n.sign ? function (e, t, n, r) {
            var o,
                i = 1 < arguments.length && void 0 !== t ? t : "",
                a = 2 < arguments.length && void 0 !== n ? n : "",
                s = 3 < arguments.length && void 0 !== r ? r : {},
                l = "json",
                c = m({}, 0 < arguments.length && void 0 !== e ? e : {});
            "function" == typeof s ? o = s : (o = s.callback, l = s.postType || "json"), function () {
              var e = [],
                  t = [];

              for (var n in c) {
                e.push(n);
              }

              if (e.sort(), e.forEach(function (e) {
                t.push(e + "=" + c[e]);
              }), i) if ("[object Object]" == Object.prototype.toString.call(i)) {
                if ("json" == l) t.push(JSON.stringify(i));else {
                  var r = [];

                  for (var n in i) {
                    r.push(n + "=" + i[n]);
                  }

                  t.push(r.join("&"));
                }
              } else t.push(i);
              t.unshift(a), t.push(a), c.signature = v(t.join("")), s.log && (console.debug("sign: ", t.join("")), console.log("H5签名前参数", t), console.log("H5签名后返回", c)), o && o(c);
            }();
          }(n.params, n.data, n.signSalt, {
            postType: "json",
            log: !1,
            callback: function callback(e) {
              n.params = e, t(n);
            }
          }) : j(n.params, n.data, {
            useH5: e,
            postType: "json",
            log: n.signLog || !1,
            appkey: n.signAppkey || n.appkey || null,
            callback: function callback(e) {
              n.params = e, t(n);
            }
          }) : t(n);
        });
      }), y.interceptors.request.on(function (t) {
        return new Promise(function (e) {
          window.kmRequestListener && window.kmRequestListener(1), e(t);
        });
      }), y.interceptors.response.on(void 0, function (e) {
        if (e && e.config && 0 < e.config.retry) {
          var t = e.config.baseURL;
          return e.config.baseURL = e.config.retryURL, e.config.retryURL = t, e.config.retry--, e.request && (e.request.abort(), e.request = null), e.config && e.config.params && e.config.params.signature && delete e.config.params.signature, y(e.config);
        }

        return window.kmRequestListener && window.kmRequestListener(2, e.code || 0), Promise.reject(e);
      }), y.interceptors.response.on(function (e) {
        try {
          e.data = JSON.parse(e.data);
        } catch (e) {}

        return e;
      }), y.interceptors.response.on(function (e) {
        return window.kmRequestListener && window.kmRequestListener(2, 200), e;
      }), y.interceptors.response.on(function (e) {
        if (e.config.isAllowKGAntiBush && e && e.data && 0 === e.data.status) {
          var t = "",
              n = "";

          try {
            t = e.headers["ssa-code"], n = e.headers["ssa-hmid"];
          } catch (e) {}

          n = n || e.config.kgAntiBushMid || e.config.params.mid || "";
          var r = e.config.kgAntiBushAppid || e.config.params.appid || "";

          if (t) {
            if (r) {
              var o = e.config.kgAntiBushURL ? e.config.kgAntiBushURL : "https://m3ws.kugou.com";
              o = encodeURIComponent(o);
              var i = "https://h5.kugou.com/apps/verify-h5/dist/#/index/".concat(t, "/").concat(e.config.kgAntiBushAppid, "/").concat(o, "/").concat(n);
              window.location.replace(i);
            } else console.error("请输入正确的参数。eventid 和 appid 不允许为空！");

            return null;
          }

          return e;
        }

        return e;
      }), y;
    });
  });
  var main_min = createCommonjsModule(function (module, exports) {
    !function (t, r) {
      module.exports = r();
    }(commonjsGlobal, function () {
      var t = {
        str2Json: function str2Json(t) {
          var r = {};
          if ("[object String]" === Object.prototype.toString.call(t)) try {
            r = JSON.parse(t);
          } catch (t) {
            r = {};
          }
          return r;
        },
        json2Str: function json2Str(t) {
          var r = t;
          if ("string" != typeof t) try {
            r = JSON.stringify(t);
          } catch (t) {
            r = "";
          }
          return r;
        },
        _extend: function _extend(t, r) {
          if (r) for (var o in t) {
            r.hasOwnProperty(o) || (r[o] = t[o]);
          }
          return r;
        },
        formatURL: {
          browser: "",
          url: ""
        },
        formatSong: {
          filename: "",
          filesize: "",
          hash: "",
          bitrate: "",
          extname: "",
          duration: "",
          mvhash: "",
          m4afilesize: "",
          "320hash": "",
          "320filesize": "",
          sqhash: "",
          sqfilesize: 0,
          feetype: 0,
          isfirst: 0
        },
        formatMV: {
          filename: "",
          singername: "",
          hash: "",
          imgurl: ""
        },
        formatShare: {
          shareName: "",
          topicName: "",
          hash: "",
          listID: "",
          type: "",
          suid: "",
          slid: "",
          imgUrl: "",
          filename: "",
          duration: "",
          shareData: {
            linkUrl: "",
            picUrl: "",
            content: "",
            title: ""
          }
        },
        cbNum: 0,
        isIOS: !!navigator.userAgent.match(/KGBrowser/gi),
        isKugouAndroid: !!navigator.userAgent.match(/kugouandroid/gi),
        isAndroid: "undefined" != typeof external && void 0 !== external.superCall,
        loadUrl: function loadUrl(t) {
          var r = document.createElement("iframe");
          r.setAttribute("src", t), r.setAttribute("style", "display:none;"), r.setAttribute("height", "0px"), r.setAttribute("width", "0px"), r.setAttribute("frameborder", "0"), document.body.appendChild(r), r.parentNode.removeChild(r), r = null;
        },
        callCmd: function callCmd(r) {
          var o = t;

          if (o.isKugouAndroid) {
            var n = {},
                e = "";

            if (r.cmd && (n.cmd = r.cmd), r.jsonStr && (n.jsonStr = r.jsonStr), r.callback && (o.cbNum++, e = "kgandroidmobilecall_" + (n.cmd || 0) + "_" + o.cbNum + Math.random().toString().substr(2, 9), n.callback = e, window[e] = function (t, n) {
              void 0 !== t && ("[object String]" === Object.prototype.toString.call(t) ? (t = "#" === n ? decodeURIComponent(t) : decodeURIComponent(decodeURIComponent(t)), r.callback(o.str2Json(t))) : r.callback(t));
            }), r.AndroidCallback) {
              var i = o.str2Json(r.jsonStr);
              i.AndroidCallback = e, r.jsonStr = o.json2Str(i), r.jsonStr && (n.jsonStr = r.jsonStr);
            }

            var a = encodeURIComponent(JSON.stringify(n)),
                c = "kugoujsbridge://start.kugou_jsbridge/?".concat(a);
            o.loadUrl(c);
          } else if (o.isAndroid) {
            var l = "",
                s = "";

            if (r.jsonStr) {
              if (r.callback && "" !== r.callback && !0 === r.AndroidCallback) {
                o.cbNum++, s = "kgmobilecall_" + (r.cmd || 0) + "_" + o.cbNum + Math.random().toString().substr(2, 9), window[s] = function (t, n) {
                  void 0 !== t && ("[object String]" === Object.prototype.toString.call(t) ? (t = "#" === n ? decodeURIComponent(t) : decodeURIComponent(decodeURIComponent(t)), r.callback(o.str2Json(t))) : r.callback(t));
                };
                var d = o.str2Json(r.jsonStr);
                d.AndroidCallback = s, r.jsonStr = o.json2Str(d);
              }

              try {
                l = external.superCall(r.cmd, r.jsonStr);
              } catch (t) {}
            } else try {
              l = external.superCall(r.cmd);
            } catch (t) {}

            r.callback && "" !== r.callback && "AndroidCallback" != l && (l = o.str2Json(l), r.callback(l));
          } else {
            var u = "",
                m = "";
            r.callback && (o.cbNum++, m = "kgmobilecall_" + (r.cmd || 0) + "_" + o.cbNum + Math.random().toString().substr(2, 9), window[m] = function (t) {
              void 0 !== t && r.callback && ("[object String]" === Object.prototype.toString.call(t) ? r.callback(o.str2Json(t)) : r.callback(t));
            }), m && "" != m && r.jsonStr && (u = 'kugouurl://start.music/?{"cmd":' + r.cmd + ', "jsonStr":' + r.jsonStr + ', "callback":"' + m + '"}'), m && "" != m && !r.jsonStr && (u = 'kugouurl://start.music/?{"cmd":' + r.cmd + ', "callback":"' + m + '"}'), "" == m && r.jsonStr && (u = 'kugouurl://start.music/?{"cmd":' + r.cmd + ', "jsonStr":' + r.jsonStr + "}"), "" != m || r.jsonStr || (u = 'kugouurl://start.music/?{"cmd":' + r.cmd + "}"), o.loadUrl(u);
          }
        },
        formartData: function formartData(r, o) {
          r && 123 == r && o && (o = t._extend(t.formatURL, o)), r && 123 == r && o && (o = t._extend(t.formatURL, o));
        }
      };
      return {
        isIOS: t.isIOS,
        isKugouAndroid: t.isKugouAndroid,
        isAndroid: t.isAndroid,
        isInClient: function isInClient() {
          return !(!t.isAndroid && !t.isKugouAndroid) || !!t.isIOS;
        },
        mobileCall: function mobileCall(r, o, n) {
          var e = "";
          if (o && (e = t.json2Str(o)), !r) return console.error("请输入命令号！"), !1;
          var i = {};
          r && (i.cmd = r), "" != e && (i.jsonStr = e), n && (i.callback = n), !r || 186 != r && 225 != r || n && (i.AndroidCallback = !0), t.callCmd(i);
        },
        KgWebMobileCall: function KgWebMobileCall(t, r) {
          if (t) try {
            var o = t.split(".");
            o.reduce(function (n, e) {
              if (n[e]) {
                if (e === o[o.length - 1]) {
                  var i = n[e];
                  return "function" == typeof i ? (n[e] = function () {
                    i && i.apply(void 0, arguments), r && r.apply(void 0, arguments);
                  }, n[e]) : (console.error("请检查，当前环境变量已注册了对象：" + t + "，且该对象不是方法"), null);
                }

                return n[e];
              }

              return e === o[o.length - 1] ? n[e] = function () {
                r && r.apply(void 0, arguments);
              } : n[e] = new Object(), n[e];
            }, window);
          } catch (t) {}
        }
      };
    });
  });
  main_min$1.requestConfig.useMobileCall = main_min.isInClient();
  main_min$1.requestConfig.retry = 0;
  main_min$1.requestConfig.sign = 'h5';
  main_min$1.requestConfig.isAllowSign = true;
  main_min$1.requestConfig.isGateway = false;
  main_min$1.requestConfig.isAllowKGAntiBush = false;
  main_min$1.requestConfig.baseURL = 'https://m3ws.kugou.com';
  var kgRequest = main_min$1;

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;

    if (!css || typeof document === 'undefined') {
      return;
    }

    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';

    if (insertAt === 'top') {
      if (head.firstChild) {
        head.insertBefore(style, head.firstChild);
      } else {
        head.appendChild(style);
      }
    } else {
      head.appendChild(style);
    }

    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }
  }

  var css = ".kg-loading-wrap{\r\n    position: fixed;\r\n    top: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    z-index: 10000;\r\n}\r\n.kg-loading .kg-loading-container .kg-loading-msg span {\r\n    color: #000;\r\n}\r\n\r\n.kg-loading.inline .kg-loading-container {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n\r\n}\r\n\r\n.kg-loading.inline .kg-loading-container .kg-loading-icon {\r\n    width: .55em;\r\n    height: .55em;\r\n    position: relative;\r\n    -ms-flex-negative: 0;\r\n        flex-shrink: 0;\r\n}\r\n\r\n.kg-loading.inline .kg-loading-container .kg-loading-icon canvas {\r\n    position: absolute;\r\n}\r\n\r\n.kg-loading.inline .kg-loading-container .kg-loading-msg {\r\n    -ms-flex-negative: 1;\r\n        flex-shrink: 1;\r\n}\r\n\r\n.kg-loading.inline .kg-loading-container .kg-loading-msg span {\r\n    font-size: .24em;\r\n    display: block;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n}\r\n\r\n\r\n.kg-loading.block .kg-loading-container {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: column;\r\n            flex-direction: column;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n}\r\n\r\n.kg-loading.block .kg-loading-container .kg-loading-icon {\r\n    width: .88em;\r\n    height: .88em;\r\n    position: relative;\r\n    -ms-flex-negative: 0;\r\n        flex-shrink: 0;\r\n}\r\n\r\n.kg-loading.block .kg-loading-container .kg-loading-icon canvas {\r\n    position: absolute;\r\n}\r\n\r\n.kg-loading.block .kg-loading-container .kg-loading-msg {\r\n    margin-top: .1em;\r\n    -ms-flex-negative: 1;\r\n        flex-shrink: 1;\r\n}\r\n\r\n.kg-loading.block .kg-loading-container .kg-loading-msg span {\r\n    font-size: .24em;\r\n    display: block;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n}\r\n\r\n.kg-loading.pop {\r\n    position: absolute;\r\n    height: 100%;\r\n    width: 100%;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 10000;\r\n}\r\n\r\n.kg-loading.pop .kg-loading-container {\r\n    padding: .2em;\r\n    background: rgba(0, 0, 0, 0.5);\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    -webkit-transform: translate(-50%, -50%);\r\n            transform: translate(-50%, -50%);\r\n    border-radius: .1em;\r\n    overflow: hidden;\r\n    z-index: 10000;\r\n}\r\n\r\n.kg-loading.pop .kg-loading-container .kg-loading-msg span {\r\n    color: #fff;\r\n}\r\n\r\n.kg-loading.pop.popBg .kg-loading-bg {\r\n    position: absolute;\r\n    top: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    z-index: 9999;\r\n}\r\n\r\n\r\n\r\n.kg-loading-icon.blue {\r\n    background: url(https://webimg.kgimg.com/c47e54633d8bd65701629ac3f3e6ee9f.png) no-repeat top center;\r\n    background-size: 100%;\r\n}\r\n\r\n.kg-loading-icon.blue:before {\r\n    content: \"\";\r\n    width: 100%;\r\n    height: 100%;\r\n    background: url(https://webimg.kgimg.com/a76d10d8a9d930969330a396361f9a4a.png) no-repeat;\r\n    background-size: 100%;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    -webkit-animation: rotateAni 1s linear infinite;\r\n    animation: rotateAni 1s linear infinite;\r\n}\r\n\r\n.kg-loading-icon.red {\r\n    background: url(https://webimg.kgimg.com/d882096843e8ba444368cb31e77e975d.png) no-repeat top center;\r\n    background-size: 100%;\r\n}\r\n\r\n.kg-loading-icon.red:before {\r\n    content: \"\";\r\n    width: 100%;\r\n    height: 100%;\r\n    background: url(https://webimg.kgimg.com/44b471990022a7f0673aee8d0933145e.png) no-repeat;\r\n    background-size: 100%;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    -webkit-animation: rotateAni 1s linear infinite;\r\n    animation: rotateAni 1s linear infinite;\r\n}\r\n\r\n@-webkit-keyframes rotateAni {\r\n    0% {\r\n        -webkit-transform: rotate(0);\r\n        transform: rotate(0);\r\n    }\r\n\r\n    100% {\r\n        -webkit-transform: rotate(360deg);\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n@keyframes rotateAni {\r\n    0% {\r\n        -webkit-transform: rotate(0);\r\n        transform: rotate(0);\r\n    }\r\n\r\n    100% {\r\n        -webkit-transform: rotate(360deg);\r\n        transform: rotate(360deg);\r\n    }\r\n}";
  styleInject(css);
  /**
   * Canvas
   * @param {*} elem 
   * @param {*} opts 
   */

  var iconInit = function iconInit(elem, opts) {
    if (typeof elem === 'string') {
      elem = document.querySelector(elem);
    } else if (elem.nodeType !== 1) {
      console.error('elem is not an Element Node');
      return;
    }

    var defaultOptions = {
      color: false,
      // 'normal', 'error', other_colors
      width: 48,
      stop: false,
      dpr: window.devicePixelRatio || 2
    };
    opts = Object.assign({}, defaultOptions, opts || {});
    var colorBlue = '#409EFF';
    var colorError = '#FF6C00';
    var KWBase = 6.6 / 144;
    var KPBase = [['moveTo', 59 / 144, 44 / 144], ['lineTo', 55 / 144, 100 / 144], ['moveTo', 90 / 144, 48 / 144], ['lineTo', 65 / 144, 70 / 144], ['lineTo', 89 / 144, 100 / 144]];
    var cache = {
      moveAngle: 0,
      secondAngle: Math.PI,
      endAngle: Math.PI / 8,
      add: 1,
      defaultSpeed: 1280 / (2 * Math.PI),
      // 根据options变化
      cvsWidth: 0,
      // 画布宽
      lineWidth: 0,
      // 线条宽
      radius: 0,
      // 半径
      center: {
        x: 0,
        y: 0
      },
      // 中心点
      KPoints: [],
      // K的路径关键点
      color: colorBlue,
      drawing: false
    };
    var cvs = document.createElement('canvas');

    if (!cvs.getContext) {
      return false;
    }

    var ctx = cvs.getContext("2d");
    cvs.style.maxWidth = '100%';
    cvs.style.maxHeight = '100%';
    cvs.style.verticalAlign = 'top';

    var changeOptions = function changeOptions(newOptions) {
      Object.assign(opts, newOptions || {});
      var W = cache.cvsWidth = (opts.width || 144) * opts.dpr;
      cache.color = !opts.color || opts.color === 'normal' ? colorBlue : opts.color === 'error' ? colorError : opts.color;
      cache.lineWidth = W * KWBase;
      cache.KPoints = KPBase.map(function (_) {
        return _.map(function (__) {
          return typeof __ === 'string' ? __ : W * __;
        });
      });
      cache.center = {
        x: W / 2,
        y: W / 2
      };
      cache.radius = W / 2 - cache.lineWidth;
      cvs.width = W;
      cvs.height = W;
      cvs.style.width = opts.width + 'px';
      cvs.style.height = opts.width + 'px';

      if (!opts.stop && cache.drawing === false) {
        draw();
      }
    };

    var draw = function draw(step) {
      cache.drawing = true;
      var C = cache.center;
      var R = cache.radius; // const KP = cache.KPoints

      var SP = step || cache.defaultSpeed;
      ctx.clearRect(0, 0, cache.cvsWidth, cache.cvsWidth);
      ctx.lineCap = "round";
      ctx.fillStyle = "#f2f2f2";
      ctx.strokeStyle = cache.color; // 绘制背景

      ctx.beginPath();
      ctx.arc(C.x, C.y, R - cache.lineWidth * 1.5, 0, Math.PI * 2, false);
      ctx.fill();
      ctx.save(); // 绘制K

      ctx.lineWidth = cache.lineWidth * 1.82;
      ctx.beginPath();
      cache.KPoints.map(function (_) {
        ctx[_[0]](_[1], _[2]);
      }); // ctx.moveTo(KP[0][0], KP[0][1])
      // ctx.lineTo(KP[1][0], KP[1][1])
      // ctx.moveTo(KP[2][0], KP[2][1])
      // ctx.lineTo(KP[3][0], KP[3][1])
      // ctx.lineTo(KP[4][0], KP[4][1])

      ctx.stroke(); // 绘制外框线条动画

      ctx.lineWidth = cache.lineWidth;
      ctx.beginPath();
      ctx.arc(C.x, C.y, R, cache.moveAngle, cache.moveAngle + cache.endAngle, false);
      ctx.stroke();
      ctx.beginPath();
      ctx.arc(C.x, C.y, R, cache.moveAngle + cache.secondAngle, cache.moveAngle + cache.secondAngle + cache.endAngle, false);
      ctx.stroke();
      cache.moveAngle += SP;

      if (cache.moveAngle >= 2 * Math.PI) {
        cache.moveAngle = 0;
      }

      if (cache.endAngle >= Math.PI / 3) {
        cache.endAngle = Math.PI / 3;
        cache.add = 0;
      } else if (cache.endAngle <= Math.PI / 24) {
        cache.endAngle = Math.PI / 24;
        cache.add = 1;
      }

      if (cache.add) {
        cache.endAngle += SP / 2;
      } else {
        cache.endAngle -= SP / 2;
        cache.moveAngle += SP / 2;
      }

      cache.lastTime = Date.now();
      requestAnimationFrame(function () {
        // 如果元素被删除，就不继续循环了
        // if (cvs.parentNode && cvs.parentNode.parentNode && !opts.stop) {//<----有bug，实际上没删掉dom的引用
        if (cvs.offsetWidth != 0 && !opts.stop) {
          // 动画时长1280ms
          var _step = (Date.now() - cache.lastTime) * 2 * Math.PI / 1280;

          draw(_step);
        } else {
          cache.drawing = false;
          cvs = null;
        }
      });
    };

    elem.appendChild(cvs);
    changeOptions();
    return {
      draw: draw,
      changeOptions: changeOptions
    };
  };
  /**
   * 获取DOM HTML
   * @param {Object} options 
   */


  var getHTML = function getHTML(options) {
    var getLoadClass = function getLoadClass() {
      var classlist = ["kg-loading"]; //显示类型

      if (options.type) {
        classlist.push(options.type);
      } //是否弹窗


      if (options.showPop) {
        classlist.push('pop');
      } // 是否显示弹窗背景


      if (options.popConfig.showBg) {
        classlist.push('popBg');
      } //是否红菊


      if (options.showLongLoad) {
        classlist.push('longLoad');
      }

      return classlist.join(" ");
    };

    var getColor = function getColor(color, styles) {
      return color ? "".concat(styles ? styles : 'background-color', ":").concat(color, ";") : '';
    };

    var kgLoad = document.createElement("div");
    kgLoad.className = getLoadClass();
    kgLoad.innerHTML = "\n        <div class=\"kg-loading-container\" style=\"".concat(getColor(options.popConfig.popColor), "\">\n            <div class=\"kg-loading-icon ").concat(options.icon || '', "\"></div>\n            <div class=\"kg-loading-msg\" style=\"").concat(options.msg && 'margin-left: .1em;', "\"><span style=\"").concat(getColor(options.color, "color"), "\">").concat(options.msg || '', "</span></div>\n        </div>\n        <div class=\"kg-loading-bg\" style=\"").concat(getColor(options.popConfig.bgColor), "\"></div>\n    ");
    kgLoad.style.fontSize = Math.min(document.querySelector("html").offsetWidth / 7.2, 60) + "px";
    return kgLoad;
  };
  /**
   * 获取DOM容器
   * @param {Object} options 
   */


  var getEle = function getEle(options) {
    if (options.ele) {
      if (typeof options.ele == "string") {
        return document.getElementById(options.ele);
      } else {
        return options.ele;
      }
    } else {
      var rand = document.createElement("div");
      rand.id = "kg-loading-" + new Date().getTime();
      rand.className = options.showPop ? "kg-loading-wrap" : "";
      document.body.appendChild(rand);
      return rand;
    }
  };
  /**
   * 删除DOM节点
   * @param {Object} ele 
   */


  var removeEle = function removeEle(ele) {
    if (ele.getElementsByClassName("kg-loading").length > 0) {
      ele.removeChild(ele.getElementsByClassName("kg-loading")[0]);

      if (ele.id && /kg-loading/.test(ele.id)) {
        document.body.removeChild(ele);
      }
    }
  };
  /**
   * 后置处理
   * @param {Object} ele 
   * @param {Object} options 
   */


  var postProcess = function postProcess(ele, options) {
    if (options.icon == 'blue_v2') {
      var canvas = ele.getElementsByClassName('blue_v2')[0];

      if (options.showLongLoad) {
        var obj = iconInit(canvas);

        if (obj == false) {
          //加载失败降级
          downGrade(ele, _objectSpread2({}, options, {}, {
            icon: 'blue'
          }));
        } else {
          setTimeout(function () {
            obj.changeOptions({
              color: "error"
            });
            ele.getElementsByClassName("kg-loading-msg")[0].innerHTML = "<span>".concat(options.longLoadConfig.msg || '加载缓慢', "</span>");
          }, Math.ceil(options.longLoadConfig.time / 1000) * 1000 || 3000);
        }
      } else {
        var obj = iconInit(canvas);

        if (obj == false) {
          //加载失败降级
          downGrade(ele, _objectSpread2({}, options, {}, {
            icon: 'blue'
          }));
        }
      }
    }

    if (options.icon == 'red_v2') {
      var _canvas = ele.getElementsByClassName('red_v2')[0];
      var obj = iconInit(_canvas, {
        color: "error"
      });

      if (obj == false) {
        //加载失败降级
        downGrade(ele, _objectSpread2({}, options, {}, {
          icon: 'red'
        }));
      }
    }

    if (options.icon == "blue") {
      if (options.showLongLoad) {
        setTimeout(function () {
          ele.getElementsByClassName("kg-loading-icon")[0].className += ' red';
          ele.getElementsByClassName("kg-loading-msg")[0].innerHTML = "<span>".concat(options.longLoadConfig.msg || '加载缓慢', "</span>");
        }, Math.ceil(options.longLoadConfig.time / 1000) * 1000 || 3000);
      }
    }

    if (options.time && options.time > 0) {
      setTimeout(function () {
        removeEle(ele);
      }, options.time);
    }
  };
  /**
   * 降级处理
   * @param {Object} ele 
   * @param {Object} options 
   */


  var downGrade = function downGrade(ele, options) {
    removeEle(ele);
    var DomEle = getEle(options);
    var DomHtml = getHTML(options);
    DomEle.appendChild(DomHtml);
    postProcess(DomEle, options);
  };
  /**
   * 统一loading组件
   * 
   * @param {JSON} options 
   * @field type 显示类型（inline：并列显示 block：块显示）
   * @field msg 消息内容 
   * @field time 显示时长（不指定无限长 毫秒）
   * @field ele DOM容器（DOM ID/对象）
   * @field icon 显示的ICON(blue red blue_v2 red_v2)
   * @field color 显示颜色（RGBA）
   * 
   * @field showPop 是否浮窗显示
   * @field popConfig 浮窗配置
   * @field popConfig-showBg 浮窗背景显示
   * @field popConfig-popColor 浮窗颜色（RGBA）
   * @field popConfig-bgColor 浮窗背景颜色（RGBA）
   * 
   * @field showLongLoad 是否显示红菊
   * @field longLoadConfig 红菊配置
   * @field longLoadConfig-time 加载多少毫秒后显示红菊
   * @field longLoadConfig-msg 显示红菊时的文案
   */


  function kgLoad() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    options = _objectSpread2({}, {
      popConfig: {}
    }, {}, {
      longLoadConfig: {}
    }, {}, {
      type: 'inline',
      icon: 'blue',
      showPop: false,
      showLongLoad: false,
      color: !options.color && options.showPop ? "white" : "black"
    }, {}, options);
    var DomEle = getEle(options);

    if (options.time == -1) {
      return removeEle(DomEle);
    }

    var DomHtml = getHTML(options);
    DomEle.appendChild(DomHtml);
    postProcess(DomEle, options);
    return DomEle;
  } //客户端ua判断，默认值h5


  var CLIENT_UA_MATCH_DICT = {
    'kugou': function kugou(ua, external) {
      return !!ua.match(/KGBrowser|kugouandroid/i) || external && external.superCall;
    },
    'fanxing': function fanxing(ua) {
      return !!ua.match(/FanXing/i);
    },
    '5sing': function sing(ua) {
      return !!ua.match(/5sing/i);
    },
    '1822': function _(ua) {
      return !!ua.match(/1822Browser/i);
    },
    'weixin': function weixin(ua) {
      return !!ua.match(/MicroMessenger/i);
    },
    'qq': function qq(ua) {
      return !!ua.match(/QQ/i);
    },
    'qzone': function qzone(ua) {
      return !!ua.match(/qzone/i);
    },
    'weibo': function weibo(ua) {
      return !!ua.match(/weibo/i);
    }
  }; // 错误状态值

  var ERROR_CODE_MAP = {
    // 1*** 为根据hash获取歌曲信息的相关code
    1000: {
      message: '不在曲库',
      toast: '客官，这首歌我们暂时没有版权，酷小狗正在帮您挥汗争取中，先听听别的呗'
    },
    1001: {
      message: '曲库不发布的内容',
      toast: '客官，这首歌我们暂时没有版权，酷小狗正在帮您挥汗争取中，先听听别的呗'
    },
    1002: {
      message: '无版权',
      toast: '客官，这首歌我们暂时没有版权，酷小狗正在帮您挥汗争取中，先听听别的呗'
    },
    1003: {
      message: '版权收费',
      toast: '应版权方要求，试听需开通音乐包'
    },
    // 自定义试听错误码
    10031: {
      message: '版权收费',
      toast: '应版权方要求，试听需开通音乐包'
    },
    // 2***为服务器相关的code
    2000: {
      message: '根据hash获取歌曲详情失败',
      toast: '网络繁忙，请稍后再试'
    },
    2001: {
      message: '根据hash获取歌曲详情请求异常',
      toast: '网络繁忙，请稍后再试'
    }
  };
  var COMMON_ERROR = {
    message: '未知错误码',
    toast: '网络繁忙，请稍后再试'
  }; // 枚举播放器状态

  var PLAY_STATUS;

  (function (PLAY_STATUS) {
    PLAY_STATUS[PLAY_STATUS["play"] = 1] = "play";
    PLAY_STATUS[PLAY_STATUS["pause"] = 2] = "pause";
    PLAY_STATUS[PLAY_STATUS["end"] = 3] = "end";
    PLAY_STATUS[PLAY_STATUS["loading"] = 4] = "loading";
    PLAY_STATUS[PLAY_STATUS["error"] = 5] = "error";
  })(PLAY_STATUS || (PLAY_STATUS = {})); // 枚举播放模式


  var PLAY_MODE;

  (function (PLAY_MODE) {
    PLAY_MODE[PLAY_MODE["single"] = 0] = "single";
    PLAY_MODE[PLAY_MODE["once"] = 1] = "once";
    PLAY_MODE[PLAY_MODE["cycle"] = 2] = "cycle";
    PLAY_MODE[PLAY_MODE["loop"] = 3] = "loop";
  })(PLAY_MODE || (PLAY_MODE = {}));

  var loadingEle = null;
  /**
   * 音频播放器
   */

  var AudioPlayer =
  /** @class */
  function () {
    /**
     * 构造函数
     * @param config 初始化配置参数
     */
    function AudioPlayer(config) {
      this.config = config; //测试值

      this.doneTest = false;
      this._CLIENT = 'h5';
      this._IS_H5_PLAYER = true;
      this._PLAY_STATUS_MAP = {}; // 私有变量
      // private _cache: { [key: string]: any } = {}

      this._eventListeners = {};
      this._songList = [];
      this._nowSongIndex = 0;
      this._playingInfo = {};
      this._userInfo = null; //公有变量

      /**
       * Cookie相关方法
       */

      this.Cookie = {
        read: function read(name, key, isJSON) {
          var cookieValue = "";
          var arrStr = document.cookie.split("; ");

          for (var i = 0; i < arrStr.length; i++) {
            var temp = arrStr[i].match(/^(\w+)=(.+)$/);

            if (temp && temp.length > 1 && temp[1] == name) {
              cookieValue = temp[2];
              break;
            }
          }

          if (cookieValue == "") {
            return null;
          } else {
            if (key) {
              if (!isJSON) {
                return new this.Param().parse(cookieValue)[key];
              } else {
                return JSON.parse(cookieValue)[key];
              }
            }

            return cookieValue;
          }
        },
        Param: function Param() {
          var o = {};

          this.parse = function (str) {
            var a = str.split("&");

            for (var i = 0, l = a.length; i < l; i++) {
              var k = a[i].split("=");
              o[k[0]] = k[1];
            }

            return o;
          };
        }
      };

      if (!(this instanceof AudioPlayer)) {
        return new AudioPlayer(config);
      }

      this.init();
    }
    /**
     * toast提示
     * @param word 提示的信息
     * @param time 延时时间，毫秒
     */


    AudioPlayer.prototype.toast = function (word, time) {
      var toastCover = document.createElement('div'),
          toastCoverExist = document.getElementById("toastCover");

      if (toastCoverExist) {
        document.body.removeChild(toastCoverExist);
      }

      var base = 'position: fixed;top: 50%;left: 50%;transform: translate(-50%, -50%);-webkit-transform: translate(-50%, -50%);z-index: 99999;line-height: 22px;background-color: rgba(0, 0, 0, 0.8);border-radius: 5px;font-size: 13px;color: #fff;text-align: center;box-sizing: content-box;';
      toastCover.style.cssText = base + (word.length <= 10 ? 'min-width: 70px;height:21px;padding: 12.5px 15px;' : 'width: 200px;padding: 12.5px 25px;');
      toastCover.id = 'toastCover';
      toastCover.innerText = word;
      document.body.appendChild(toastCover);

      if (window.toastTimeout) {
        clearTimeout(window['toastTimeout']);
      }

      window.toastTimeout = setTimeout(function () {
        if (document.querySelector('#toastCover')) {
          toastCover.parentNode.removeChild(toastCover);
        }
      }, time || 2000);
    };
    /**
     * 音频播放器初始化
     */


    AudioPlayer.prototype.init = function () {
      window._h5audiocache = window._h5audiocache || {};
      window._h5audioReqcache = window._h5audioReqcache || {};
      this.configJudge();
      this.envJudge();
      this.getUserInfo();
      this.createAudio();
      this.setRequest();
    };

    AudioPlayer.prototype.setRequest = function () {
      var _this = this; // 添加响应拦截器


      kgRequest.interceptors.response.on(function (response) {
        // 处理风控
        if (response.data && response.data.errcode === 1002) {
          var eventid_1 = '';
          var mid_1 = '';

          if (response.resHeaders) {
            eventid_1 = response.resHeaders["ssa-code"];
            mid_1 = response.resHeaders["ssa-hmid"];
          } else if (response.headers) {
            eventid_1 = response.headers["ssa-code"];
            mid_1 = response.headers["ssa-hmid"];
          } //this.toast(response.data.error || '操作频繁，请稍后重试~')


          if (window.KgUser) {
            setTimeout(function () {
              window['KgUser'].antiBrushH5({
                eventid: eventid_1,
                userid: _this._userInfo.userid,
                appid: _this._userInfo.appid,
                mid: mid_1,
                url: window.location.href
              });
            }, 1000);
          } else {
            _this.loadScript("https://staticssl.kugou.com/common/js/min/login/kguser.v2.min.js?v=20190313", function (e) {
              if (e) return;
              setTimeout(function () {
                window['KgUser'].antiBrushH5({
                  eventid: eventid_1,
                  userid: _this._userInfo.userid,
                  appid: _this._userInfo.appid,
                  mid: mid_1,
                  url: window.location.href
                });
              }, 1000);
            });
          }
        }

        return response;
      }, function (err) {
        _this.toast("网络异常，请稍后重试~");

        return err;
      });
    };
    /**
     * 初始化参数判断
     */


    AudioPlayer.prototype.configJudge = function () {
      var SOURCE_LIST = ['hash', 'url'];
      var lowerSourType = '';

      if (this.config.sourceType && !~SOURCE_LIST.indexOf(lowerSourType = this.config.sourceType.toLowerCase())) {
        throw new Error("source " + this.config.sourceType + " is not accepted!");
      } else {
        this.config.sourceType = lowerSourType || 'hash';
      }

      if (!this.config.hasOwnProperty('errorToast')) {
        this.config.errorToast = true;
      }

      if (this.config.errorToastMap) {
        Object.assign(ERROR_CODE_MAP, this.config.errorToastMap);
      }

      this.updateSongList(this.config.songList);
      this.changePlayMode(this.config.playMode);
    };
    /**
     * 环境判断
     */


    AudioPlayer.prototype.envJudge = function () {
      this._UA = navigator.userAgent;
      this._IS_IOS = !!this._UA.match(/iPad|iPhone|iPod/i);

      if (this.config.env) {
        this._CLIENT = this.config.env;
        return;
      }

      for (var key in CLIENT_UA_MATCH_DICT) {
        if (CLIENT_UA_MATCH_DICT[key](this._UA, window.external)) {
          this._CLIENT = key;
          return;
        }
      }
    };
    /**
     *
     * 获取用户信息
     */


    AudioPlayer.prototype.getUserInfo = function (callback) {
      var _this = this;

      if (this.config.userInfo) {
        this._userInfo = this.config.userInfo;
      }

      if (this._userInfo) return callback && callback(this._userInfo);
      var userInfo = Object.create(null);

      switch (this._CLIENT) {
        case 'kugou':
          // 异步获取，避免ios中同时调客户端命令号出问题的bug
          setTimeout(function () {
            main_min.mobileCall(101, null, function (uInfo) {
              userInfo.userid = uInfo.kugouID || 0;
              userInfo.appid = uInfo.appid || 1058;
              userInfo.token = uInfo.token || '';
              main_min.mobileCall(122, null, function (verInfo) {
                userInfo.clientver = verInfo.version;
                main_min.mobileCall(124, null, function (mobileInfo) {
                  userInfo.mid = mobileInfo.mid_v2 || mobileInfo.mid;
                  userInfo.dfid = mobileInfo.dfid || '-';
                  _this._userInfo = userInfo;
                  callback && callback(_this._userInfo);
                });
              });
            });
          }, 50);
          break;

        default:
          // 默认cookie拿数据
          userInfo.userid = this.Cookie.read("KuGoo", "KugooID") || 0;
          userInfo.mid = this.Cookie.read("kg_mid");
          userInfo.dfid = this.Cookie.read("kg_dfid") || '-';
          userInfo.appid = this.Cookie.read("KuGoo", "a_id") || 1058;
          userInfo.token = this.Cookie.read("KuGoo", "t") || '';
          this._userInfo = userInfo;
          callback && callback(this._userInfo);
      }
    };
    /**
     * 更新歌单
     * @param songList 歌单
     */


    AudioPlayer.prototype.updateSongList = function (songList) {
      var _this = this;

      if (songList && songList.length) {
        var itemString = typeof songList[0] === 'string';

        if (itemString) {
          this._songList = songList.map(function (ele) {
            var _a;

            return _a = {}, _a[_this.config.sourceType] = ele, _a;
          });
        } else {
          this._songList = JSON.parse(JSON.stringify(songList));
        }
      }
    };
    /**
     * 后添加歌单
     * @param songList 歌单
     */


    AudioPlayer.prototype.addSongList = function (songList) {
      var _a, _b;

      var _this = this;

      if (songList && songList.length) {
        var itemString = typeof songList[0] === 'string';

        if (itemString) {
          (_a = this._songList).push.apply(_a, songList.map(function (ele) {
            var _a;

            return _a = {}, _a[_this.config.sourceType] = ele, _a;
          }));
        } else {
          (_b = this._songList).push.apply(_b, JSON.parse(JSON.stringify(songList)));
        }
      }
    };
    /**
     * 修改播放模式
     * @param playMode 播放模式
     */


    AudioPlayer.prototype.changePlayMode = function (playMode) {
      this._playMode = PLAY_MODE[playMode] || 0; //默认single单首歌曲播放
    };
    /**
     * 音频创建
     */


    AudioPlayer.prototype.createAudio = function () {
      var _this = this;

      switch (this._CLIENT) {
        case 'kugou':
          this._IS_H5_PLAYER = false;

          if (window.KgWebMobileCall) {
            window.KgWebMobileCall.playStatus = function (res) {
              return _this.config.playStatus(typeof res === 'string' ? JSON.parse(res) : res);
            };
          } else {
            window.KgWebMobileCall = {
              playStatus: function playStatus(res) {
                return _this.config.playStatus(typeof res === 'string' ? JSON.parse(res) : res);
              }
            };
          }

          break;

        case 'fanxing':
          this._IS_H5_PLAYER = false;
          break;

        case '5sing':
          this._IS_H5_PLAYER = false;
          break;

        default:
          this.createH5Audio();
      }
    };
    /**
     * 创建h5播放器
     */


    AudioPlayer.prototype.createH5Audio = function () {
      if (this._PLAYER_ID) return;
      var time = Math.floor(new Date().valueOf() / 1000);
      var ID = 'Player' + time;
      var audio = document.createElement('audio');
      audio.id = ID;
      audio.style.display = 'none';
      document.body.appendChild(audio);
      this._PLAYER_ID = ID;
      this._PLAYER = audio; // 事件监听

      this.addEventListeners(audio);
    };
    /**
     * 异步请求方法
     * @param method 方法名
     * @param url 请求url
     * @param callback 回调方法
     */


    AudioPlayer.prototype._ajaxMsg = function (method, url, params, callback) {
      var pdata = {
        method: method,
        url: url,
        params: params
      };

      if (this.config.referer) {
        pdata = Object.assign(pdata, {
          headers: [{
            'Referer': window.location.href
          }]
        });
      } // 客户端内代理写死Referer和User-Agent


      if (kgRequest.requestConfig.useMobileCall) {
        pdata = Object.assign(pdata, {
          headers: [{
            'Referer': 'https://h5.kugou.com'
          }, {
            'User-Agent': window.navigator.userAgent
          }]
        });
      }

      if (this.config.useMobileCall != undefined) {
        pdata = Object.assign(pdata, {
          useMobileCall: this.config.useMobileCall
        });
      }

      kgRequest(pdata).then(function (res) {
        callback(null, res.data);
      })["catch"](function (e) {
        callback(e, null);
      }); // return;
      //   let xhr = new XMLHttpRequest();
      //   xhr.onreadystatechange = function () {
      //       if (xhr.readyState == 4) {
      //           try {
      //               if (xhr.status === 304 || (xhr.status >= 200 && xhr.status < 300)) {
      //                   callback(null, xhr)
      //               } else {
      //                   callback(xhr, null)
      //               }
      //           } catch (e) {
      //               callback(e, null)
      //           }
      //       }
      //   }
      //   xhr.open(method, url, true)
      //   xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;charset=utf-8')
      //   xhr.setRequestHeader('Accept', 'application/json, text/plain, */*')
      //   xhr.send()
    };

    AudioPlayer.prototype.loadingStyle = function () {
      function loadCssCode(code) {
        var style = document.createElement('style');
        style.type = 'text/css';
        style.appendChild(document.createTextNode(code));
        var head = document.getElementsByTagName('head')[0];
        head.appendChild(style);
      }

      loadCssCode('.kg-loading{z-index:100;position:fixed;top:0;left:0;width:100%;height:100%;}.kg-loading-container{height:100%;}');
    };
    /**
     * 单独调用获取歌曲信息的预检查
     * @param hash 音频hash值
     */


    AudioPlayer.prototype.checkBeforeGetSongInfoByHash = function (hashInfo, callback) {
      var _this = this;

      this.getUserInfo(function () {
        _this.getSongInfoByHash(hashInfo, callback);
      });
    };
    /**
     * 根据音频hash获取歌曲信息
     * @param hash 音频hash值
     */


    AudioPlayer.prototype.getSongInfoByHash = function (hashInfo, callback) {
      var _this = this;

      var hash = hashInfo.hash;

      if (!this._userInfo) {
        return this.checkBeforeGetSongInfoByHash(hashInfo, callback);
      }

      this._playingInfo[hash] = hashInfo; // 读取缓存

      var getCache = window._h5audiocache[hash];
      var resCache = window._h5audioReqcache[hash];

      if (getCache) {
        var songStatus = getCache.status;

        if (songStatus == 1 || this._CLIENT === 'kugou') {
          if (songStatus != 1) {
            // 酷狗内所有都由客户端处理
            callback && callback(null, getCache);

            this._emitStatus('error', {
              source: hash,
              error_code: getCache.ctype,
              res: resCache
            });
          } else if (getCache.trans_param && getCache.trans_param.hash_offset) {
            if (getCache.audition_status != 0) {
              this._emitStatus('error', {
                source: hash,
                error_code: getCache.ctype + '1',
                res: resCache
              });
            }

            if (this._CLIENT === 'kugou') {
              callback && callback(null, getCache);
            } else if (this.config.sectionListen) {
              callback && callback(null, getCache);
            } else {
              this._emitStatus('error', {
                source: hash,
                error_code: getCache.ctype,
                res: resCache
              });

              callback && callback({
                code: getCache.ctype,
                message: getCache.error
              }, getCache);
            }
          } else {
            callback && callback(null, getCache);
          }
        } else {
          this._emitStatus('error', {
            source: hash,
            error_code: getCache.ctype,
            res: resCache
          });

          callback && callback({
            code: getCache.ctype,
            message: getCache.error
          }, getCache);
        }

        return;
      } // 判断是否歌手页,这里祖传代码这样写，可能依赖了url


      var from = ~location.href.indexOf("singer") ? 'singer' : 'mkugou';
      var platid = 4;
      var getSongInfoParam = {
        "cmd": "playInfo",
        "hash": hash,
        "from": from,
        "apiver": 2,
        "platid": platid,
        "appid": this._userInfo.appid,
        "uid": this._userInfo.userid,
        'token': this._userInfo.token,
        "clientver": this._userInfo.clientver || 2000
      };
      Object.assign(getSongInfoParam, this._userInfo, hashInfo);

      this._emitStatus('loading', {
        source: hash
      });

      if (this.config.reqLoading) {
        this.loadingStyle();
        loadingEle = kgLoad({
          icon: 'blue_v2',
          type: 'inline',
          ele: document.querySelector("body")
        });
      }

      this._ajaxMsg('get', "/v1/song/info", getSongInfoParam, function (err, res) {
        if (loadingEle) {
          kgLoad({
            time: -1,
            ele: loadingEle
          });
        }

        if (err) {
          _this._emitStatus('error', {
            source: hash,
            error_code: 2001,
            err: err,
            res: res
          });
        } else {
          if (!res) return;

          if (res.status == 1) {
            window._h5audiocache[hash] = res.data;
            window._h5audioReqcache[hash] = res;
            var songStatus = res.data.status;

            if (songStatus == 1 || _this._CLIENT === 'kugou') {
              if (songStatus != 1) {
                // 酷狗内所有都由客户端处理
                callback && callback(null, res.data);

                _this._emitStatus('error', {
                  source: hash,
                  error_code: res.data.ctype,
                  res: res
                });
              } else if (res.data.trans_param && res.data.trans_param.hash_offset) {
                if (res.data.audition_status != 0) {
                  _this._emitStatus('error', {
                    source: hash,
                    error_code: res.data.ctype + '1',
                    res: res
                  });
                }

                if (_this._CLIENT === 'kugou') {
                  callback && callback(null, res.data);
                } else if (_this.config.sectionListen) {
                  callback && callback(null, res.data);
                } else {
                  _this._emitStatus('error', {
                    source: hash,
                    error_code: res.data.ctype,
                    res: res
                  });

                  callback && callback({
                    code: res.data.ctype,
                    message: res.data.error
                  }, res.data);
                }
              } else {
                callback && callback(null, res.data);
              }
            } else {
              _this._emitStatus('error', {
                source: hash,
                error_code: res.data.ctype,
                res: res
              });

              callback && callback({
                code: res.data.ctype,
                message: res.data.error
              }, res.data);
            }
          } else {
            _this._emitStatus('error', {
              source: hash,
              error_code: 2000,
              res: res
            });
          }
        }
      });
    };
    /**
     * 动态加载js脚本
     * @param src 脚本src
     * @param callback 加载回调
     */


    AudioPlayer.prototype.loadScript = function (src, callback) {
      var script = document.createElement('script');
      script.type = 'text/javascript';

      script.onreadystatechange = function () {
        if (script.readyState == "loaded" || script.readyState == "complete") {
          script.onreadystatechange = script.onload = null;
          callback && callback(null);
        }
      };

      script.onload = function () {
        callback && callback(null);
      };

      script.onerror = function (e) {
        callback && callback(e);
      };

      script.src = src;
      document.querySelector('head').appendChild(script);
    };
    /**
     * 添加音频节点事件监听
     * @param event 事件名
     * @param callback 回调
     */


    AudioPlayer.prototype.on = function (event, callback) {
      var _this = this;

      if (!this._IS_H5_PLAYER) {
        throw new Error('客户端不可监听事件');
      }

      if (!this._PLAYER) {
        throw new Error('音频节点未创建，不可监听事件');
      }

      var add = this.addEvent(this._PLAYER);
      add(event, function (e) {
        if (!_this._playingSource) return;
        callback(_this._playingSource, e);
      });
    };
    /**
     * 添加音频节点事件单次监听后移除事件
     * @param event 事件名
     * @param callback 回调
     */


    AudioPlayer.prototype.once = function (event, callback) {
      var self = this;

      if (!this._IS_H5_PLAYER) {
        throw new Error('客户端不可监听事件');
      }

      if (!this._PLAYER) {
        throw new Error('音频节点未创建，不可监听事件');
      }

      function onceCb(e) {
        self.removeEvent(event, onceCb);
        return callback(self._playingSource, e);
      }

      var add = this.addEvent(this._PLAYER);
      add(event, onceCb);
    };
    /**
     * 状态告知
     * @param status
     * @param error_code
     */


    AudioPlayer.prototype._emitStatus = function (enum_status, config) {
      var _a, _b;

      var status = PLAY_STATUS[enum_status];
      if (!this.config.playStatus || !this._IS_H5_PLAYER && status != 5) return;
      var source = config && config.source || this._playingSource;
      if (!this.doneTest || !source) return;

      if (status == 5) {
        //'error'的情况
        if (!config.error_code) {
          throw new Error('there must be an error code when status equals 0');
        }

        var errorCodeItem = ERROR_CODE_MAP[config.error_code];

        if (typeof errorCodeItem === 'undefined') {
          errorCodeItem = _assign({}, COMMON_ERROR, {
            message: COMMON_ERROR.message + ": " + config.error_code
          });
        }

        if (this.config.errorToast && this._IS_H5_PLAYER) {
          this.toast(errorCodeItem.toast);
        }

        this.updatePlayStatusMap(source, {
          status: status,
          error_code: config.error_code,
          message: errorCodeItem.message,
          err: config.err,
          res: config.res
        });
        var obj = (_a = {
          status: status
        }, _a[this.config.sourceType] = source, _a.error_code = config.error_code, _a.message = errorCodeItem.message, _a.err = config.err, _a.res = config.res, _a);

        if (this._playingInfo[source] && this._playingInfo[source].album_audio_id) {
          obj = Object.assign(obj, {
            album_audio_id: this._playingInfo[source].album_audio_id
          });
        }

        this.config.playStatus(obj);
        this._IS_H5_PLAYER && this._emitStatus('end', {
          source: source
        });
      } else {
        this.updatePlayStatusMap(source, {
          status: status
        });
        var obj = (_b = {
          status: status
        }, _b[this.config.sourceType] = source, _b);

        if (this._playingInfo[source] && this._playingInfo[source].album_audio_id) {
          obj = Object.assign(obj, {
            album_audio_id: this._playingInfo[source].album_audio_id
          });
        }

        this.config.playStatus(obj);
      }
    };
    /**
     * 更新播放状态表
     * @param source 播放源
     * @param config 状态内容
     */


    AudioPlayer.prototype.updatePlayStatusMap = function (source, config) {
      this._PLAY_STATUS_MAP[source] = config;
    };
    /**
     * 添加监听器
     * @param audio 添加事件的音频对象节点
     */


    AudioPlayer.prototype.addEventListeners = function (audio) {
      var _this = this;

      var add = this.addEvent(audio);
      add('playing', function (e) {
        if (!_this.doneTest) return;

        _this._emitStatus('play');
      });
      add('pause', function (e) {
        if (!_this.doneTest) return;
        !_this._PLAYER.ended && _this._emitStatus('pause');
      });
      add('ended', function (e) {
        if (!_this.doneTest) return;

        switch (_this._playMode) {
          case 0:
            //single
            _this._emitStatus('end');

            break;

          case 1:
            //once
            _this._emitStatus('end');

            _this.playNextButNotLoop();

            break;

          case 2:
            //cycle
            _this._PLAYER.play();

            break;

          case 3:
            //loop
            _this._emitStatus('end');

            _this.playNext();

            break;
        }
      });
    };
    /**
     * 音频添加监听
     * @param audio 添加事件的音频对象节点
     */


    AudioPlayer.prototype.addEvent = function (audio) {
      var _this = this;

      return function (event, callback) {
        if (_this._eventListeners[event]) {
          return _this._eventListeners[event].push(callback);
        } else {
          _this._eventListeners[event] = [callback];
          audio.addEventListener(event, function (e) {
            return _this._eventListeners[event].forEach(function (ele) {
              return ele(e);
            });
          });
        }
      };
    };
    /**
     * 音频监听移除
     * 此处默认为保存的事件
     */


    AudioPlayer.prototype.removeEvent = function (event, callback) {
      var target = this._eventListeners[event];
      if (!target) return;

      if (callback) {
        var findIndex = -1;

        for (var i = 0; i < target.length; i++) {
          var ele = target[i];

          if (ele === callback) {
            findIndex = i;
            break;
          }
        }

        ~findIndex && target.splice(findIndex, 1);
      } else {
        delete this._eventListeners[event];
      }
    };
    /**
     * 播放歌曲
     * @param source 播放源
     */


    AudioPlayer.prototype.play = function (source, playIndex) {
      var _a;

      var _this = this;

      if (!source && this._IS_H5_PLAYER) {
        //浏览器，src为空时，src = window.location.href
        this._PLAYER.src && this._PLAYER.src != window.location.href && this._PLAYER.play && this._PLAYER.paused && this._PLAYER.play() || this._songList.length && this.play(this._songList[playIndex || 0]);
        return;
      }

      var sourceKey = this.config.sourceType;
      var itemString = typeof source === 'string'; //兼容旧的传参方式

      var index = -1;

      if (source) {
        if (itemString) {
          //旧方式传的hash：string
          // 如果现有歌曲列表没有将要播放的歌曲，则将它放进去
          if (this._songList.length > 0) {
            for (var i = 0; i < this._songList.length; i++) {
              var ele = this._songList[i];

              if (ele[sourceKey] === source) {
                index = i;
                break;
              }
            }
          }

          !~index && this._songList.push((_a = {}, _a[sourceKey] = source, _a));
        } else {
          // 如果现有歌曲列表没有将要播放的歌曲，则将它放进去
          if (this._songList.length > 0) {
            for (var i = 0; i < this._songList.length; i++) {
              var ele = this._songList[i];

              if (ele[sourceKey] === source[sourceKey]) {
                index = i;
                break;
              }
            }
          }

          !~index && this._songList.push(JSON.parse(JSON.stringify(source)));
        }
      } else {
        if (playIndex) {
          //兼容songlist，情况从里面获取歌曲
          if (sourceKey === 'url') {
            source = this._songList[playIndex][sourceKey];
          } else {
            source = this._songList[playIndex];
          }
        }
      }
      /* if (sourceKey === 'url' || this._IS_H5_PLAYER) {
          //没有传播放歌曲或是url（h5播放）的话，则h5默认从头开始播放
          if(sourceKey === 'url'){
              source = source[sourceKey] || this._songList[0][sourceKey]
          }else{
              source = source || this._songList[0]
          }
      } */


      switch (sourceKey) {
        case 'url':
          this.doneTest = true;

          this._playStart(source, source, ~index ? index : this._songList.length - 1);

          break;
        // 默认是hash

        default:
          this.getUserInfo(function () {
            if (~['kugou'].indexOf(_this._CLIENT)) {
              _this.doneTest = true;
            }

            if (!_this.doneTest) {
              _this._PLAYER.src = '';

              _this.once('play', function () {
                _this.doneTest = true;
              });

              try {
                var tedtP = _this._PLAYER.play();

                if (tedtP instanceof Promise) {
                  tedtP["catch"](function (e) {});
                }
              } catch (e) {}
            } // 没有source则为客户端全部添加列表播放


            if (!source) {
              _this._playStart('', '', 0, true);

              return;
            }

            _this.getSongInfoByHash(source, function (err, data) {
              if (err) return;
              var src = data.url;

              _this._playStart(src, source[sourceKey], ~index ? index : _this._songList.length - 1);
            });
          });
      }
    };
    /**
     * 停止正在播放的歌曲
     */


    AudioPlayer.prototype.pause = function () {
      switch (this._CLIENT) {
        case 'kugou':
          main_min.mobileCall(125, {
            type: 3
          });
          break;

        default:
          this._PLAYER.pause && this._PLAYER.pause();
      }
    };

    AudioPlayer.prototype.resume = function () {
      switch (this._CLIENT) {
        case 'kugou':
          main_min.mobileCall(125, {
            type: 4
          });
          break;

        default:
          this._PLAYER.play && this._PLAYER.play();
      }
    };
    /**
     * 控制播放歌曲的下标
     * @param index 歌曲的下标
     */


    AudioPlayer.prototype.songIndexControl = function (index) {
      var lastIndex = this._songList.length - 1;

      if (index < 0) {
        return lastIndex;
      } else if (index > lastIndex) {
        return 0;
      } else {
        return index;
      }
    };
    /**
     * 播放上一首
     */


    AudioPlayer.prototype.playPre = function () {
      if (!this._songList.length) return;
      this.config.sourceType;
      this.play(this._songList[this.songIndexControl(this._nowSongIndex - 1)]);
    };
    /**
     * 播放下一首
     */


    AudioPlayer.prototype.playNext = function () {
      if (!this._songList.length) return;
      this.config.sourceType;
      this.play(this._songList[this.songIndexControl(this._nowSongIndex + 1)]);
    };
    /**
     * 播放下一首，但列表播放结束不循环
     */


    AudioPlayer.prototype.playNextButNotLoop = function () {
      var len = this._songList.length;
      if (!len || this._nowSongIndex + 1 > len - 1) return;
      this.config.sourceType;
      this.play(this._songList[this._nowSongIndex + 1]);
    };
    /**
     * 开始播放音频
     * @param src 播放url，只限制为string
     */


    AudioPlayer.prototype._playStart = function (src, source, songIndex, multiple) {
      var _this = this;

      if (this._IS_H5_PLAYER) {
        if (this._playingSource && source !== this._playingSource || !this._PLAYER.paused) {
          this._emitStatus('end'); //this._PLAYER.pause()
          //return;

        }

        this._PLAYER.src = src;
        this._playingSource = source;

        if (this._PLAYER.play) {
          this.once('play', function () {
            _this._nowSongIndex = songIndex;
          });

          this._PLAYER.play();
        }

        return;
      }

      switch (this._CLIENT) {
        case 'kugou':
          /* if (!window['LightMobileCall']) {
              throw new Error('you need to import LightMobileCall first')
          } */
          var data = {};

          if (multiple) {
            data = {
              total: this._songList.length,
              info: this._songList
            };
            var dataExpandFix = this.config.dataExpandFix;

            if (dataExpandFix) {
              data = Object.assign(data, dataExpandFix);
            }
          } else {
            var res = window._h5audiocache[source];
            var mixId = res['album_audio_id'];
            var extra = res.extra || {};
            var info_1 = {
              /** 最小必传 */
              //【必传】 mp3名称（歌手名 - 歌曲名）
              filename: res.fileName || '',
              // 【必传】歌曲哈希
              hash: res.hash || '',
              // 【必传】歌曲文件大小
              filesize: res.fileSize || 0,
              // 【必传】歌曲比特率
              bitrate: res.bitRate || 0,
              // 【必传】后缀名
              extname: res.extName || '',
              //【必传】 歌曲长度 单位秒
              duration: res.timeLength || 0,
              // 【必传】同 duration iOS不传会导致X秒试听歌曲BAR条显示错误
              timelength: res.timeLength || 0,
              // 【必传】album_audio_id = mixid = mixsongid 安卓不传会导致网络收藏重复
              mixId: mixId,
              // 【必传】，试听信息，无权限歌曲，提示开会员等
              privilege: res.privilege,
              // 【必传】安卓兼容需要，这个key必传，value可以是空字符串
              mvhash: res.mvhash || '',
              // 【必传】安卓兼容需要，这个key必传，value可以是空字符串
              sqhash: extra.sqhash || '',
              // 试听信息，透传接口返回
              trans_param: res.trans_param || {},

              /** 非必传音质相关 */
              // 128
              '128hash': extra['128hash'] || '',
              '128filesize': extra['128filesize'] || 0,
              '128bitrate': extra['128bitrate'] || 0,
              '128timelength': extra['128timelength'] || 0,
              '128privilege': res['128privilege'] || 0,
              // sq
              sqfilesize: extra.sqfilesize || 0,
              sqbitrate: res.sqbitrate || extra.sqbitrate || 0,
              sqtimelength: res.sqtimelength || extra.sqtimelength || 0,
              sqprivilege: res.sqprivilege || undefined,
              // 320
              '320hash': extra['320hash'] || '',
              '320filesize': extra['320filesize'] || 0,
              '320bitrate': res['320bitrate'] || extra['320bitrate'] || 0,
              '320timelength': extra['320timelength'] || 0,
              '320privilege': res['320privilege'] || extra['320privilege'] || undefined,
              // high-res音质
              hash_high: extra.highhash || res.high_hash || '',
              filesize_high: extra.highfilesize || res.high_filesize || 0,
              timelength_high: extra.hightimelength || res.timelength || 0,
              bitrate_high: extra.highbitrate || res.high_bitrate || 0,
              privilege_high: extra.highprivilege || res.highprivilege || res.high_privilege || undefined,

              /** 会员付费字段 */
              store_type: res.store_type || undefined,
              pay_type: res.pay_type || undefined,
              fail_process: res.fail_process || undefined,
              old_cpy: res.old_cpy || undefined,

              /** 非必传其他字段 */
              // 专辑id
              album_id: res.albumid || 0,
              // 试听提示方法
              audition: res.audition_status || undefined,
              // m4a文件长度
              m4afilesize: res.m4afilesize || undefined,
              feetype: 0,
              isfirst: 0,

              /** 兼容字段 */
              album_audio_id: mixId
            }; // 移除未定义字段

            Object.keys(info_1).forEach(function (key) {
              if (typeof info_1[key] === 'undefined') {
                console.log("delete " + key);
                delete info_1[key];
              }
            });
            var infoFix = this.config.infoFix;
            var infoDynamic = this.config.infoDynamic;
            var dataExpandDynamic = this.config.dataExpandDynamic;
            var dataExpandFix = this.config.dataExpandFix; //传res中的参数

            if (infoDynamic) {
              var infoObj = {};

              for (var index = 0; index < infoDynamic.length; index++) {
                var element = infoDynamic[index];
                infoObj[element] = res[element];
              }

              info_1 = Object.assign(info_1, infoObj);
            } //固定的参数


            if (infoFix) {
              info_1 = Object.assign(info_1, infoFix);
            }

            data = {
              total: 1,
              info: [info_1]
            };

            if (dataExpandDynamic) {
              var dataObj = {};

              for (var i = 0; i < dataExpandDynamic.length; i++) {
                var element = dataExpandDynamic[i];
                dataObj[element] = res[element];
              }

              data = Object.assign(data, dataObj);
            }

            if (dataExpandFix) {
              data = Object.assign(data, dataExpandFix);
            }
          }

          console.log('108 data:', data);
          main_min.mobileCall(108, data);
          break;
      }
    };
    /**
     * 获取歌曲状态集
     */


    AudioPlayer.prototype.getPlayStatusMap = function () {
      return this._PLAY_STATUS_MAP;
    };
    /**
     * 设置播放进度,仅支持h5播放器
     */


    AudioPlayer.prototype.setPosition = function (num, ifPercent) {
      if (ifPercent === void 0) {
        ifPercent = false;
      }

      if (!this._PLAYER) return;
      var duration = this._PLAYER.duration;
      if (!duration) return;

      if (ifPercent) {
        this._PLAYER.currentTime = duration * num;
      } else {
        this._PLAYER.currentTime = num;
      }
    };

    return AudioPlayer;
  }();

  return AudioPlayer;
});